import { jsonObjToRecoilState } from "./atoms";
import ReactDOMServer from "react-dom/server";
import { TbLayoutNavbar, TbLayoutBottombar, TbSection } from "react-icons/tb";
import { MdOutlineOndemandVideo, MdOutlineSmartButton, MdGroups } from "react-icons/md";
import { parseHTMLToJson } from "./codeParser";
import { RiLayoutMasonryFill } from "react-icons/ri";
import { RiLayoutFill } from "react-icons/ri";
import {
  FaUserCircle,
  FaFeatherAlt,
  FaVideo,
  FaLinkedin,
  FaTwitter,
  FaRegComments,
  FaGithub
} from "react-icons/fa";
import {
  FaSackDollar,
  FaAngleDown,
  FaRegImage,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import {
  AiFillTwitterCircle,
  AiFillLinkedin,
  AiFillGithub,
} from "react-icons/ai";
import { FaArrowRightLong } from "react-icons/fa6";
import { FiLogIn } from "react-icons/fi";
import { PiStarFill } from "react-icons/pi";
import { BiSolidOffer } from "react-icons/bi";

export const assetCategories = [
  {
    categ: "sections",
    name: "Sections",
    icon: <TbSection className="w-5 h-5" />,
  },
  {
    categ: "elements",
    name: "Elements",
    icon: <RiLayoutMasonryFill className="w-5 h-5" />,
  },
  {
    categ: "navs",
    name: "Navbars",
    icon: <TbLayoutNavbar className="w-5 h-5" />,
  },
  { categ: "hero", name: "Hero", icon: <RiLayoutFill className="w-5 h-5" /> },
  {
    categ: "people",
    name: "People",
    icon: <MdGroups className="w-5 h-5" />,
  },
  {
    categ: "features",
    name: "Features",
    icon: <FaFeatherAlt className="w-4 h-4" />,
  },
  {
    categ: "pricing",
    name: "Pricing",
    icon: <FaSackDollar className="w-5 h-5" />,
  },
  {
    categ: "cta-section",
    name: "CTAs",
    icon: <MdOutlineSmartButton className="w-5 h-5" />,
  },
  { categ: "faqs", name: "FAQs", icon: <FaRegComments className="w-5 h-5" /> },
  {
    categ: "footer",
    name: "Footer",
    icon: <TbLayoutBottombar className="w-5 h-5" />,
  },
  {
    categ: "misc",
    name: "Others",
    icon: <MdOutlineOndemandVideo className="w-5 h-5" />,
  },

  // {categ:'media', name: 'Media', icon: <MdOutlineOndemandVideo className="w-5 h-5"/>},
  // {categ:'buttons', name: 'Buttons', icon: <MdOutlineSmartButton className="w-7 h-auto"/>},
  // {categ:'texts', name: 'Texts', icon: <BiText className="w-5 h-5"/>},
];

export const assets = [
  {
    name: "Container",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-10 h-6 border border-dashed border-zinc-400 rounded-lg"></div>
        <div className="text-zinc-300 text-xs font-semibold">Container</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <div className="p-4 text-foreground font-body">Placeholder Text</div>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Row",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="gap-2 flex flex-row">
          <div className="w-8 h-8 bg-zinc-700 rounded-md"></div>
          <div className="w-8 h-8 bg-zinc-700 rounded-md"></div>
          <div className="w-8 h-8 bg-zinc-700 rounded-md"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Row</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
          <div className="p-4 flex flex-row gap-4 w-full font-body text-foreground">
            <div className="w-1/3 bg-grayshade-500 rounded-md p-6 bg-opacity-60">Container 1</div>
            <div className="w-1/3 bg-grayshade-500 rounded-md p-6 bg-opacity-60">Container 2</div>
            <div className="w-1/3 bg-grayshade-500 rounded-md p-6 bg-opacity-60">Container 3</div>
          </div>
        `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Column",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="gap-2 flex flex-col">
          <div className="w-12 h-6 bg-zinc-700 rounded-md "></div>
          <div className="w-12 h-6 bg-zinc-700 rounded-md "></div>
          <div className="w-12 h-6 bg-zinc-700 rounded-md"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Column</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <div className="p-4 flex flex-col gap-4 w-full font-body text-foreground">
        <div className="w-full bg-grayshade-500 rounded-m p-6 bg-opacity-60">Container 1</div>
        <div className="w-full bg-grayshade-500 rounded-md p-6 bg-opacity-60">Container 2</div>
        <div className="w-full bg-grayshade-500 rounded-md p-6 bg-opacity-60">Container 3</div>
      </div>
    `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "List",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-2 items-center justify-center rounded-2xl text-xs text-zinc-300">
        <div className="flex gap-1">
          <div className="rounded-full w-2 h-2 bg-zinc-700"></div>
          <div className="rounded-lg w-12 h-2 bg-zinc-700"></div>
        </div>
        <div className="flex gap-1">
          <div className="rounded-full w-2 h-2 bg-zinc-700"></div>
          <div className="rounded-lg w-12 h-2 bg-zinc-700"></div>
        </div>
        <div className="flex gap-1">
          <div className="rounded-full w-2 h-2 bg-zinc-700"></div>
          <div className="rounded-lg w-12 h-2 bg-zinc-700"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">List</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <ul className="flex flex-col gap-3 text-foreground font-body">
        <li className="list-disc">Item 1</li>
        <li className="list-disc">Item 2</li>
        <li className="list-disc">Item 3</li>
      </ul>
    `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Button Primary",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-28 py-2 text-xs bg-lime-600 text-zinc-200 rounded-lg flex items-center justify-center">
          Btn Primary
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <button className="px-8 py-2 rounded-md bg-primary text-foreground hover:opacity-80 duration-200 font-semibold">Button</button>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Button Secondary",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-28 py-2 text-xs bg-zinc-600 text-zinc-100 rounded-lg flex items-center justify-center">
          Btn Secondary
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <button className="px-8 py-2 rounded-md bg-secondary opacity-80 text-white hover:opacity-100 duration-200 font-semibold">Button</button>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Button Outline",
    categ: ["elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-28 py-2 text-xs border border-lime-600 text-lime-600 rounded-lg flex items-center justify-center">
          Btn Outline
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <button className="px-8 py-2 rounded-md border border-primary text-primary hover:bg-primary hover:text-foreground duration-200 font-semibold">Button</button>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Hero Header",
    categ: ["texts", "elements", "hero"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="border border-dashed border-zinc-500 px-3 py-2 text-white text-lg font-bold tracking-tight">
          Hero Header
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <h1 className="text-5xl sm:text-6xl font-extrabold text-foreground font-heading capitalize w-full md:w-[700px] lg:w-[900px] leading-snug">Hero Header</h1>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Heading",
    categ: ["texts", "elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="border border-dashed border-zinc-500 px-2 py-1 text-white text-base font-semibold tracking-tight">
          Heading
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <h2 className="text-2xl font-extrabold text-foreground font-heading capitalize ">Heading</h2>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Secondary Text",
    categ: ["texts", "elements"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="border border-dashed border-zinc-500 px-2 py-1 text-zinc-200 text-sm">
          Secondary text
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <h2 className="text-base font-normal text-foreground font-body">Secondary Text</h2>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Image",
    categ: ["media", "elements", "image"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl ">
        <FaRegImage className="text-zinc-500 w-7 h-auto" />
        <div className="text-zinc-300 text-xs font-semibold ">Image</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711828617961" alt="image description" className="object-cover w-80 h-80 rounded"/>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Video",
    categ: ["media", "elements", "video"],
    thumbnail: (
      <div className="w-full py-3 flex flex-col gap-1 items-center justify-center rounded-2xl ">
        <FaVideo className="text-zinc-500 w-7 h-auto" />
        <div className="text-zinc-300 text-xs font-semibold">Video</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <iframe width="560" height="315" className="p-2" src="https://www.youtube.com/embed/1-TZqOsVCNM?si=k_pkq8quEIUqoDXh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      `;
      return jsonObjToRecoilState({ ...parseHTMLToJson(htmlCode) });
    },
  },
  {
    name: "Hero Linear",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="flex-grow p-1 flex flex-col gap-2 items-center justify-center">
            <div className="bg-zinc-700 rounded-xl w-2/3 h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-1/3 h-2"></div>
            <div className="bg-lime-600 rounded-xl w-1/4 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Linear</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="home" className="bg-background text-foreground font-body w-screen min-h-screen flex flex-col items-center gap-5 px-6 sm:px-12 md:px-20 py-10 sm:py-20" data-aos="fade-up">
        <h1 className="text-5xl sm:text-[52px] mt-16 text-center font-extrabold tracking-wider capitalize w-full md:w-[700px] lg:w-[900px] leading-snug font-heading">
          The Simplest way to build & publish websites with
          <span className=" text-primary relative">
            <svg className="absolute inset-x-0 -bottom-1 fill-accent/80 fill-foreground scale-150" viewBox="0 0 666 42" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M220.475 4.24483C147.138 3.4005 73.5014 6.48612 2.51671 19.4427C1.25022 19.6729 0.724462 20.1258 0.62084 20.2294C0.0144608 20.8435 -0.0508949 21.4959 0.0258619 22.0332C0.071916 22.3594 0.382916 23.7372 2.08308 23.8792C3.25746 23.9751 11.5931 23.3035 14.8092 23.1308C29.9495 22.321 45.0593 21.1659 60.1612 19.8303C94.4024 16.8138 128.597 14.204 162.892 11.8284C182.147 10.4928 201.409 9.3875 220.66 8.48177C266.971 9.02291 313.167 11.1338 358.5 13.3136C340.481 14.4228 323.925 15.5473 310.197 16.2765C287.047 17.5046 263.939 18.9552 240.835 20.8665C228.965 21.8451 217.11 22.9083 205.262 24.1632C203.95 24.3052 200.96 24.4511 199.513 24.6238C198.899 24.6928 198.454 24.8042 198.254 24.8809C197.003 25.3645 196.846 26.3546 196.831 26.8535C196.823 27.1567 196.926 28.8108 199.037 29.1332C297.182 44.262 399.576 26.6617 498.074 41.3683C499.229 41.541 500.312 40.7427 500.484 39.5837C500.657 38.4285 499.859 37.3462 498.7 37.1735C405.932 23.3227 309.705 38.133 216.818 27.2604C224.935 26.4736 233.056 25.7636 241.184 25.092C264.246 23.1846 287.311 21.7377 310.423 20.5096C333.68 19.2777 365.12 16.8713 398.029 15.3554C426.272 16.9289 454.499 18.6943 482.746 20.191C494.662 20.8204 506.583 21.3424 518.495 21.9833C523.393 22.2443 535.992 23.3381 537.819 22.9313C539.239 22.6127 539.58 21.5957 539.665 21.0853C539.753 20.5326 539.699 19.8456 539.055 19.1894C538.855 18.9821 538.257 18.5523 537.028 18.1992C503.812 8.6852 449.422 8.83487 398.482 11.1337C387.525 10.5197 376.568 9.93633 365.607 9.41055C340.516 8.20163 315.147 6.98885 289.633 6.03323C361.535 4.25631 433.472 4.76676 505.427 6.05243C535.639 6.59357 617.074 9.85575 649.147 12.738C648.756 13.1409 648.525 13.7013 648.552 14.3115C648.606 15.4782 649.6 16.3839 650.77 16.3302C657.387 16.0232 661.213 15.6317 662.729 15.2287C663.673 14.9793 664.188 14.5801 664.425 14.3192C665.009 13.6898 665.116 13.0143 665.001 12.3733C664.928 11.9742 664.748 11.5367 664.333 11.1337C664.057 10.8574 663.382 10.4353 662.23 10.1474C649.623 7.01191 541.476 2.45636 505.504 1.8116C410.445 0.115274 315.424 -0.230098 220.475 4.24483ZM511.315 17.3625C492.74 14.8411 470.964 13.9545 448.248 14.0121C459.819 14.6837 471.394 15.34 482.972 15.9541C492.417 16.4568 501.866 16.8867 511.315 17.3625ZM132.865 9.72143C108.495 11.5175 84.1514 13.4595 59.7888 15.6087C56.9757 15.8543 54.1664 16.0961 51.3532 16.334C78.2949 13.0335 105.517 10.9342 132.865 9.72143Z"></path></svg>
            AI
          </span>.
        </h1>
        <p className="text-base sm:text-lg opacity-80 md:w-[600px] w-full tracking-wider text-center leading-loose">
          Use text or image prompts to build or make changes using AI. Ask
          AI to update texts, add animations, gradients or just anything using first of its kind fully AI controlled No-Code Builder.
        </p>
        <div className="flex gap-4 mt-5">
          <button className="border-2 border-primary text-foreground font-semibold text-xl px-14 py-4 rounded-full transform hover:scale-105 transition duration-300 ease-in-out">
            <div className="flex items-center justify-start gap-2">
              Get Started
            </div>
          </button>
        </div>
        <div className="flex gap-2 items-center mt-8 text-sm">
          <div className="relative flex">
            <img className="rounded-full w-[35px] h-[35px] border border-grayshade-300" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818859357" alt="Founder 1"  loading="lazy" referrerpolicy="no-referrer" />
            <img className="rounded-full w-[35px] h-[35px] border border-grayshade-300 ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818822435" alt="Founder 2"  loading="lazy" referrerpolicy="no-referrer" />
            <img className="rounded-full w-[35px] h-[35px] border border-grayshade-300 ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818841412" alt="Founder 3"  loading="lazy" referrerpolicy="no-referrer" />
          </div>
          <span className="opacity-80">Trusted by Founders</span>
        </div>
      </section>`;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero Left",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center gap-2">
          <div className="flex-grow p-1 flex flex-col gap-2 items-start justify-center w-1/2">
            <div className="bg-zinc-700 rounded-xl w-full h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-2"></div>
            <div className="w-full flex gap-1">
              <div className="bg-lime-600 rounded-xl w-1/3 h-2"></div>
              <div className="bg-zinc-700 rounded-xl w-1/3 h-2"></div>
            </div>
          </div>
          <div className="bg-zinc-700 w-1/2 h-10 rounded-lg"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Left</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <div class="bg-background text-foreground font-body w-screen">
        <nav class="items-center px-6 sm:px-12 md:px-20 py-6 mx-auto w-full flex sm:space-x-6">
          <a href="/">
            <img
              src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6648dbd3bf990150a7f8fb98/image-1716051317834"
              width="120"
              height="50"
              alt="Shopee Logo"
            />
          </a>
          <ul class="flex-1 items-center flex space-x-3 sm:space-x-6 justify-end font-semibold">
            <li class="text-foreground space-x-3 sm:space-x-6 hidden sm:block">
              <a href="/customers">Customers</a>
              <a href="/careers">Careers</a>
            </li>
            <li>
              <a href="/signup" class="flex gap-2 items-center text-white bg-primary/80 px-4 py-2 rounded-md hover:bg-primary/100 duration-200">
                Sign Up
                ${toStr(
                  <FiLogIn className="w-6 h-auto" />
                )}
              </a>
            </li>
          </ul>
        </nav>
      <section id="home" data-aos="fade-up" class="mx-auto w-full pb-12 px-6 sm:px-12 md:px-20 items-center lg:flex">
        <div class="space-y-6 flex-1 sm:text-center lg:text-left">
          <h1 class="text-foreground font-bold text-4xl xl:text-5xl font-heading">
            AI-Powered Solution for
            <span class="text-primary"> Building Websites</span>
          </h1>
          <p class="text-foreground opacity-80 max-w-xl leading-relaxed sm:mx-auto lg:ml-0">
            Transform your website creation process with our advanced AI builder. Simplify your workflow and create stunning designs effortlessly.
          </p>
          <div class="items-center justify-center space-y-3 space-x-2 sm:space-x-6 sm:space-y-0 flex flex-col sm:flex-row lg:justify-start">
            <a href="" class="w-full sm:w-fit font-semibold font-heading text-lg bg-gradient-to-r from-primary/90 hover:from-primary hover:via-primary via-primary/90 to-foreground/80 hover:to-foreground text-background text-center rounded-md shadow-md px-7 py-3">
              Get Started
            </a>
            <a href="" class="w-full sm:w-fit font-semibold font-heading text-lg bg-foreground/20 text-foreground text-center rounded-md px-7 py-3">
              Learn more
            </a>
          </div>
        </div>
        <div class="flex-1 text-center mt-7 lg:mt-0 lg:ml-3">
          <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6648dbd3bf990150a7f8fb98/image-1716112724809" class="w-full mx-auto sm:w-10/12 lg:w-full" />
        </div>
      </section>
  </div>
`;
                
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero Rounded",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex flex-col gap-3 items-center justify-center">
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="flex-grow p-1 flex flex-col gap-2 items-start justify-center w-1/2">
              <div className="bg-zinc-700 rounded-xl w-full h-2"></div>
              <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-2"></div>
              <div className="w-full flex gap-1">
                <div className="bg-lime-600 rounded-xl w-1/3 h-2"></div>
                <div className="bg-zinc-700 rounded-xl w-1/3 h-2"></div>
              </div>
            </div>
            <div className="bg-zinc-700 w-1/2 h-10 rounded-xl"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Rounded</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="home" class="bg-background text-foreground font-body w-screen py-28 px-6 sm:px-12 md:px-20">
        <div class="flex flex-col md:flex-row items-center justify-between gap-12 overflow-hidden">
          <div class="flex flex-col gap-6 sm:max-w-lg lg:max-w-xl">
            <div class="space-y-2">
              <p class="text-foreground font-medium text-sm flex gap-1 items-center">
                <span class="text-primary flex items-center gap-1">${toStr(<BiSolidOffer className="w-6 h-auto animate-pulse"/>)} $100 Off</span> for Early Adopters
              </p>
              <h1 class="font-heading font-extrabold text-foreground text-4xl md:text-5xl">Empowering startups with <span class="text-primary">AI-driven</span> web solutions</h1>
            </div>
            <p class="opacity-80">
              Transform your vision into reality with our cutting-edge AI technology, ensuring seamless growth and revenue generation.
            </p>
            <div class="flex flex-col items-center gap-3 space-y-3 sm:space-y-0 sm:flex-row">
              <a href="/" class="inline-block w-full sm:w-fit py-2 px-5 text-center text-white font-medium bg-primary/90 rounded-md shadow-lg hover:bg-primary/100 hover:shadow-none duration-200">
                Get Started Today
              </a>
              <a href="/" class="inline-flex w-full sm:w-fit items-center justify-center gap-2 py-2 px-5 text-foreground/70 border border-foreground/50 rounded-md hover:text-foreground/100 active:bg-foreground/50 font-medium duration-200">
                Learn More ${toStr(<FiLogIn className="w-6 h-auto" />)}
              </a>
            </div>
            <div class="pt-8 flex items-center gap-2 text-sm">
              <div class="flex">
                <img class="w-[35px] h-[35px] rounded-full border-2 border-background" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818859357" alt="Founder 1" loading="lazy" referrerpolicy="no-referrer" />
                <img class="w-[35px] h-[35px] rounded-full border-2 border-background ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818822435" alt="Founder 2" loading="lazy" referrerpolicy="no-referrer" />
                <img class="w-[35px] h-[35px] rounded-full border-2 border-background ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818841412" alt="Founder 3" loading="lazy" referrerpolicy="no-referrer" />
              </div>
              <div class="flex flex-col opacity-80 items-start"><div class="flex items-center gap-1">${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}</div><div>Trusted by Founders</div></div>
            </div>
          </div>
          <div class="md:max-w-xl">
            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716631211677" alt="" class="rounded-xl md:rounded-2xl" />
          </div>
        </div>
      </section>
  `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero with demo",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 pb-0 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="flex-grow p-1 flex flex-col gap-2 items-center justify-center">
            <div className="bg-lime-600 rounded-xl w-2/3 h-2"></div>
            <div className="bg-zinc-600 opacity-80 rounded-xl w-1/3 h-1"></div>
            <div className="bg-lime-600 rounded-xl w-1/6 h-2"></div>
            <div className="bg-zinc-200 rounded-t-md w-2/3 h-8"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero with Demo</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section id="home" className="bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 pt-10">
          <div class="w-full mx-auto py-28 gap-12">
            <div data-aos='fade-up' class="space-y-6 max-w-4xl mx-auto text-center flex flex-col items-center">
              <h2 class="text-4xl text-foreground font-extrabold mx-auto md:text-5xl font-heading">
                  Speed Up Website Creation with our <span class="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">AI-powered</span> Website Builder
              </h2>
              <p class="max-w-2xl mx-auto text-foreground/70 font-semibold">
                  Utilize our AI technology to create stunning websites quickly and easily. Our extensive features are designed to enhance your workflow and creativity.
              </p>
              <div class="flex items-center justify-center gap-3 space-y-3 sm:space-y-0">
                <a href="/" class="block py-2 px-4 text-white font-medium bg-primary duration-200 hover:bg-primary/80 active:bg-primary/80 rounded-lg shadow-lg hover:shadow-none">
                  Let's Get Started
                </a>
                <a href="/" class="block py-2 px-4 text-foreground/80 hover:text-foreground/100 font-medium duration-200 active:bg-foreground/20 border rounded-lg">
                  Explore More
                </a>
              </div>
              <div class="pt-8 flex items-center  gap-2 text-sm">
                <div class="relative flex">
                  <img class="w-[35px] h-[35px] rounded-full border-2 border-background" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818859357" alt="Founder 1" loading="lazy" referrerpolicy="no-referrer" />
                  <img class="w-[35px] h-[35px] rounded-full border-2 border-background ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818822435" alt="Founder 2" loading="lazy" referrerpolicy="no-referrer" />
                  <img class="w-[35px] h-[35px] rounded-full border-2 border-background ml-[-12px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818841412" alt="Founder 3" loading="lazy" referrerpolicy="no-referrer" />
                </div>
                <div class="flex flex-col opacity-80 items-start"><div class="flex items-center gap-1">${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}${toStr(<PiStarFill className="w-4 h-auto text-yellow-600"/>)}</div><div>Trusted by Founders</div></div>
              </div>
            </div>
            <div data-aos="fade-up" className="mt-20 w-[90%] mx-auto md:w-[80%] max-w-[1600px] border-[2px] border-foreground/30 rounded-[15px] bg-foreground/20" style={{boxShadow: 'rgba(0, 0, 0, 0.9) 2px 3px 12px'}}>
              <div className='w-full py-5 px-4 flex gap-2'>
                <div className='w-3 h-3 rounded-full bg-red-400'></div>
                <div className='w-3 h-3 rounded-full bg-yellow-400'></div>
                <div className='w-3 h-3 rounded-full bg-lime-400'></div>
              </div>
              <div className="p-0 border-t-[1px] border-foreground/10">
                <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713545055259" class="w-full rounded-b-2xl h-auto" alt="app demo" />
              </div>
            </div>
          </div>
        </section>`;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero with gradient",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center gap-2">
          <div className="flex-grow p-1 flex flex-col gap-2 items-start justify-center w-1/2">
            <div className="bg-zinc-700 rounded-xl w-full h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-2"></div>
            <div className="w-full flex gap-1">
              <div className="bg-lime-600 rounded-xl w-1/3 h-2"></div>
              <div className="bg-zinc-700 rounded-xl w-1/3 h-2"></div>
            </div>
          </div>
          <div className="bg-zinc-700 w-1/2 h-10 rounded-lg"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Snippet</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="home" className="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20">
        <div>
            <div class="w-full mx-auto py-28 gap-12 overflow-hidden flex flex-col md:flex-row md:items-center" data-aos='fade-up'>
                <div class="flex-none space-y-7 max-w-xl">
                  <a href="/" class="flex items-center gap-2 w-fit shadow-md p-2 border border-primary/10 text-sm rounded-full duration-200 hover:bg-primary/20 hover:border-primary/20">
                    <p class="ml-2 text-foreground/80">
                      <span class="text-primary font-bold">100+ Founders</span>use Makeweb.ai
                    </p>
                    <div class="flex">
                      <img class="w-[24px] h-[24px] rounded-full border-2 border-background" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818859357" alt="Founder 1" loading="lazy" referrerpolicy="no-referrer" />
                      <img class="w-[24px] h-[24px] rounded-full border-2 border-background ml-[-8px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818822435" alt="Founder 2" loading="lazy" referrerpolicy="no-referrer" />
                      <img class="w-[24px] h-[24px] rounded-full border-2 border-background ml-[-8px]" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818841412" alt="Founder 3" loading="lazy" referrerpolicy="no-referrer" />
                    </div>
                  </a>
                  <h1 class="text-4xl text-foreground font-heading font-extrabold sm:text-6xl">
                    Create Your SaaS with AI Precision
                  </h1>
                  <p class='text-foreground/80 text-lg font-semibold'>
                    Utilize our AI-powered builder to craft the perfect SaaS product, tailored exactly to your needs. Streamline development with advanced automation.
                  </p>
                  <div class="flex items-center gap-3 sm:text-sm">
                    <a href="/" class="flex items-center justify-center gap-2 px-7 py-3 text-background font-medium bg-foreground duration-200 hover:bg-foreground/80 active:bg-foreground/90 rounded-full md:inline-flex">
                      Get Started
                      ${toStr(<FaArrowRightLong className="w-4 h-auto"/>)}
                    </a>
                    <a href="/" class="flex items-center justify-center gap-2 px-7 py-3 text-foreground hover:text-foreground/80 font-medium duration-200 md:inline-flex">
                      Learn More
                    </a>
                  </div>
                </div>
                <div class="flex-1">
                  <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716642296455" class="w-full object-cover" />
                </div>
            </div>
        </div>
      </section>`;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero Centered Grid",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="flex-grow p-1 flex flex-col gap-2 items-center justify-center">
            <div className="bg-zinc-700 rounded-xl w-2/3 h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-1/3 h-2"></div>
            <div className="bg-lime-600 rounded-xl w-1/4 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Centered Grid</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="home" class="relative overflow-hidden bg-[url('https://preline.co/assets/svg/examples/squared-bg-element.svg')] bg-no-repeat bg-top size-full transform text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-20">
        <div data-aos="fade-up" class="max-w-[85rem] mx-auto">
          <div class="flex justify-center">
            <a class="inline-flex items-center gap-x-2 bg-background border border-foreground/10 text-xs font-medium text-foreground/80 p-2 px-3 rounded-full transition hover:border-foreground/60" href="#">
              Discover the AI Builder
              <span class="flex items-center gap-x-1">
                <span class="border-s border-foreground/10 text-primary ps-2">Learn More</span>
                <svg class="flex-shrink-0 size-4 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
              </span>
            </a>
          </div>
          <div class="mt-5 max-w-9xl text-center mx-auto">
            <h1 class="block font-bold text-foreground text-4xl md:text-5xl lg:text-6xl font-heading">
              Empower Your Development
            </h1>
          </div>
          <div class="mt-5 max-w-3xl text-center mx-auto">
            <p class="text-lg text-foreground/80">Experience the future of web development with our AI-powered builder, designed to streamline your workflow.</p>
          </div>
          <div class="mt-8 gap-3 flex justify-center">
            <a class="inline-flex justify-center items-center gap-x-3 text-center bg-gradient-to-tl from-primary to-violet-600 hover:from-violet-600 hover:to-primary border border-transparent text-white text-sm font-medium rounded-full py-3 px-4" href="#">
              ${toStr(<FaGithub class="flex-shrink-0 w-4 h-auto"/>)}  
              Continue with Github
            </a>
          </div>
        </div>
      </section>`;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Navbar Simple",
    categ: ["sections", "navs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="rounded bg-lime-600 w-3 h-3"></div>
          <div className="rounded bg-zinc-700 w-16 h-1"></div>
          <div className="flex gap-1">
            <div className="rounded bg-zinc-600 w-3 h-2"></div>
            <div className="rounded bg-lime-600 w-3 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Navbar Simple
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="header" class="flex flex-wrap md:justify-start md:flex-nowrap z-50 w-full py-4 px-6 sm:px-12 md:px-20 bg-background text-foreground font-body">
        <nav class="relative max-w-7xl w-full flex flex-wrap md:grid md:grid-cols-12 basis-full items-center mx-auto" aria-label="Global">
          <div class="md:col-span-3">
            <a class="flex-none rounded-xl text-xl inline-block font-semibold focus:outline-none focus:opacity-80" href="../templates/creative-agency/index.html" aria-label="AIBuilder">
              <img class="w-auto h-8" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713539128214" alt="AI Builder Logo"/>
            </a>
          </div>
          <!-- Button Group -->
          <div class="flex items-center gap-x-2 ms-auto py-1 md:ps-6 md:order-3 md:col-span-3">
            <a href="" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-xl border border-foreground/20 text-foreground hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none">
              Sign In
            </a>
            <a href="" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-xl border border-transparent bg-primary text-background hover:bg-primary/90 transition disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-primary/90">
              Get Started
            </a>
      
            <div class="md:hidden">
              <button id="mobile-menu-button" type="button" class="hs-collapse-toggle size-[38px] flex justify-center items-center text-sm font-semibold rounded-xl border border-foreground/20 text-foreground hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none" data-hs-collapse="#navbar-collapse-with-animation" aria-controls="navbar-collapse-with-animation" aria-label="Toggle navigation">
                <svg class="hs-collapse-open:hidden flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="18" y2="18"/></svg>
                <svg class="hs-collapse-open:block hidden flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
              </button>
            </div>
          </div>
          <!-- End Button Group -->
      
          <!-- Collapse -->
          <div id="navbar-collapse-with-animation" class="hidden overflow-hidden transition-all duration-300 basis-full grow md:block md:w-auto md:basis-auto md:order-2 md:col-span-6">
            <div class="flex flex-col gap-y-4 gap-x-0 mt-5 md:flex-row md:justify-center md:items-center md:gap-y-0 md:gap-x-7 md:mt-0">
              <div>
                <a class="relative inline-block text-foreground before:absolute before:bottom-0.5 before:start-0 before:-z-[1] before:w-full before:h-1 before:bg-primary" href="#" aria-current="page">Home</a>
              </div>
              <div>
                <a class="inline-block text-foreground/80 hover:text-primary" href="#">Features</a>
              </div>
              <div>
                <a class="inline-block text-foreground/80 hover:text-primary" href="#">Pricing</a>
              </div>
              <div>
                <a class="inline-block text-foreground/80 hover:text-primary" href="#">Resources</a>
              </div>
              <div>
                <a class="inline-block text-foreground/80 hover:text-primary" href="#">Contact</a>
              </div>
            </div>
          </div>
        </nav>
        <div id="mobile-menu" className='top-20 absolute bg-background hidden w-full flex flex-col items-center gap-8 py-4 border-b border-foreground/80'>
          <div>
            <a class="relative inline-block text-foreground before:absolute before:bottom-0.5 before:start-0 before:-z-[1] before:w-full before:h-1 before:bg-primary" href="#" aria-current="page">Home</a>
          </div>
          <div>
            <a class="inline-block text-foreground/80 hover:text-primary" href="#">Features</a>
          </div>
          <div>
            <a class="inline-block text-foreground/80 hover:text-primary" href="#">Pricing</a>
          </div>
          <div>
            <a class="inline-block text-foreground/80 hover:text-primary" href="#">Resources</a>
          </div>
          <div>
            <a class="inline-block text-foreground/80 hover:text-primary" href="#">Contact</a>
          </div>
        </div>
      </section>
      `;
      const script = `
        document.getElementById('mobile-menu-button').addEventListener('click', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if (mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.remove('hidden');
          } else {
            mobileMenu.classList.add('hidden');
          }
        });
        window.addEventListener('resize', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if(window.innerWidth > 768) {
            mobileMenu.classList.add('hidden');
          }
        });
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode), script};
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Navbar Fixed",
    categ: ["sections", "navs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="rounded bg-lime-600 w-3 h-3"></div>
          <div className="rounded bg-zinc-700 w-16 h-1"></div>
          <div className="flex gap-1">
            <div className="rounded bg-zinc-600 w-3 h-2"></div>
            <div className="rounded bg-lime-600 w-3 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Navbar Fixed
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <nav className="fixed top-0 left-0 w-screen bg-background text-foreground bg-opacity-80 backdrop-blur-sm z-50">
          <div className="flex py-4 md:py-6 px-6 sm:px-12 md:px-20 justify-between items-center ">
            <a href="/" className='flex items-center gap-3 text-3xl font-body font-medium'><img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713539128214" alt="Logo of Makeweb.ai" className='h-10 w-10'/>BrandName</a>
            <div className="hidden lg:flex gap-10 items-center text-md text-foreground/90 ">
              <a href="/" className='opacity-80 hover:opacity-100 duration-200'>Home</a>
              <a href="#features" className='opacity-80 hover:opacity-100 duration-200'>Features</a>
              <a href="#pricing" className='opacity-80 hover:opacity-100 duration-200'>Pricing</a>
              <a href="#faqs" className='opacity-80 hover:opacity-100 duration-200'>FAQs</a>
            </div>
            <div className="hidden md:flex gap-6 items-center">
              <a aria-label="LogIn to Makeweb.ai" href='/login' className="bg-transparent text-foreground  border border-foreground px-7 py-[8px] rounded-full hover:bg-foreground/70 hover:text-background active:bg-foreground/60 hover:border-foreground/80 duration-200">LogIn</a>
              <a aria-label="Get Started with Makeweb.ai" href='/' className="bg-primary text-white font-semibold px-7 py-[9px] rounded-full hover:bg-primary/80 active:bg-primary/60 duration-200 flex gap-2 items-center">
                Get Started
              </a>
            </div>
            <button id='mobile-menu-button' aria-label="Mobile menu button" className='md:hidden'>
              <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" class="w-8 h-auto text-foreground" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z" fill="currentColor"></path></svg>
            </button>
          </div>
          <div id="mobile-menu" className='bg-background bg-opacity-80 backdrop-blur-sm text-foreground hidden w-full flex flex-col items-center gap-8 py-4 border-b border-zinc-800'>
            <a href="/" className='opacity-90 hover:opacity-100 duration-200'>Home</a>
            <a href="#features" className='opacity-90 hover:opacity-100 duration-200'>Features</a>
            <a href="#pricing" className='opacity-90 hover:opacity-100 duration-200'>Pricing</a>
            <a href="#faqs" className='opacity-90 hover:opacity-100 duration-200'>FAQs</a>
            <a aria-label="LogIn to Makeweb.ai" href='/login' className="bg-transparent text-zinc-300  border border-zinc-400 px-7 py-[8px] rounded-full hover:bg-zinc-800 hover:border-zinc-600 duration-200">LogIn</a>
            <a aria-label="Get Started with Makeweb.ai" href='/' className="bg-primary text-white font-semibold px-7 py-[9px] rounded-full hover:bg-primary duration-200 flex gap-2 items-center">
              Get Started
            </a>
          </div>
        </nav>
      `;
      const script = `
        document.getElementById('mobile-menu-button').addEventListener('click', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if (mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.remove('hidden');
          } else {
            mobileMenu.classList.add('hidden');
          }
        });
        window.addEventListener('resize', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if(window.innerWidth > 768) {
            mobileMenu.classList.add('hidden');
          }
        });
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode), script };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Navbar Makeweb",
    categ: ["sections", "navs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full px-3 py-2 bg-zinc-800 rounded-full flex justify-between items-center">
          <div className="rounded bg-lime-600 w-3 h-3"></div>
          <div className="rounded bg-zinc-700 w-16 h-1"></div>
          <div className="flex gap-1">
            <div className="rounded bg-zinc-600 w-3 h-2"></div>
            <div className="rounded bg-lime-600 w-3 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Navbar Rounded Center
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <nav className="fixed top-4 md:top-6 left-0 w-screen z-50 flex justify-center bg-transparent px-4">
          <div className="w-full md:w-3/4 p-3 rounded-full bg-primary/5 border border-foreground/20 text-foreground bg-opacity-80 backdrop-blur-sm ">
            <div className="flex justify-between items-center ">
              <a href="/" className='flex items-center gap-2 text-2xl font-body font-semibold'><img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713539128214" alt="Logo of Makeweb.ai" className='h-10 w-10 rounded-full'/>Logo</a>
              <div className="hidden lg:flex gap-10 items-center text-md text-foreground/90 ">
                <a href="/" className='opacity-80 hover:opacity-100 duration-200'>Home</a>
                <a href="#features" className='opacity-80 hover:opacity-100 duration-200'>Features</a>
                <a href="#pricing" className='opacity-80 hover:opacity-100 duration-200'>Pricing</a>
                <a href="#faqs" className='opacity-80 hover:opacity-100 duration-200'>FAQs</a>
              </div>
              <div className="hidden md:flex gap-6 items-center">
                <a aria-label="LogIn to Makeweb.ai" href='/login' className="text-foreground/80  px-7 py-[7px] rounded-full bg-foreground/10 hover:bg-foreground/30 hover:text-background active:bg-foreground/60 duration-200">LogIn</a>
                <a aria-label="Get Started with Makeweb.ai" href='/' className="bg-primary/90 text-white font-semibold px-7 py-[8px] rounded-full hover:bg-primary/100 active:bg-primary/80 duration-200 flex gap-2 items-center">
                  Get Started
                </a>
              </div>
              <button id='mobile-menu-button' aria-label="Mobile menu button" className='md:hidden mr-5'>
                <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" class="w-8 h-auto text-foreground" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z" fill="currentColor"></path></svg>
              </button>
            </div>
          </div>
          <div id="mobile-menu" className='mx-3 top-20 absolute bg-background rounded-md bg-opacity-80 backdrop-blur-sm text-foreground hidden w-full flex flex-col items-center gap-8 py-4 border-b border-zinc-800'>
            <a href="/" className='opacity-90 hover:opacity-100 duration-200'>Home</a>
            <a href="#features" className='opacity-90 hover:opacity-100 duration-200'>Features</a>
            <a href="#pricing" className='opacity-90 hover:opacity-100 duration-200'>Pricing</a>
            <a href="#faqs" className='opacity-90 hover:opacity-100 duration-200'>FAQs</a>
            <a aria-label="LogIn to Makeweb.ai" href='/login' className="text-foreground/80  px-7 py-[7px] rounded-full bg-foreground/10 hover:bg-foreground/30 hover:text-background active:bg-foreground/60 duration-200">LogIn</a>
            <a aria-label="Get Started with Makeweb.ai" href='/' className="bg-primary text-white font-semibold px-7 py-[9px] rounded-full hover:bg-primary duration-200 flex gap-2 items-center">
              Get Started
            </a>
          </div>
        </nav>
      `;
      const script = `
        document.getElementById('mobile-menu-button').addEventListener('click', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if (mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.remove('hidden');
          } else {
            mobileMenu.classList.add('hidden');
          }
        });
        window.addEventListener('resize', function() {
          var mobileMenu = document.getElementById('mobile-menu');
          if(window.innerWidth > 768) {
            mobileMenu.classList.add('hidden');
          }
        });
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode), script };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Demo Section",
    categ: ["sections", "misc"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 border-zinc-800 border-8 bg-zinc-800 bg-opacity-70 rounded-xl text-zinc-300 flex justify-center items-center">
          <MdOutlineOndemandVideo className="w-10 h-auto text-zinc-500" />
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Demo</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="demo" className="w-full bg-background text-foreground font-body flex flex-col items-center gap-3 py-20">
        <div data-aos="fade-up" className="relative mt-20 w-[90%] mx-auto md:w-[80%] max-w-[1600px] border-[2px] border-foreground/30 rounded-[15px] bg-foreground/20" style={{boxShadow: 'rgba(0, 0, 0, 0.9) 2px 3px 12px'}}>
          <svg width="62" height="61" viewBox="0 0 62 61" fill="none" xmlns="http://www.w3.org/2000/svg" class="hidden md:block absolute -right-[50px] -top-[50px]"><path fillRule="evenodd" clipRule="evenodd" d="M6.236 24.907C7.589 17.17 8.728 9.381 10.167 1.658a1.142 1.142 0 0 0-2.245-.418C6.484 8.973 5.342 16.77 3.99 24.518a1.14 1.14 0 1 0 2.246.39ZM37.122 37.885c6.435-6.703 12.528-13.728 18.817-20.564a1.142 1.142 0 0 0-1.682-1.546c-6.276 6.827-12.355 13.84-18.78 20.528a1.142 1.142 0 0 0 1.645 1.582ZM51.104 57.785c2.93-.263 5.83-.498 8.749-.846a1.14 1.14 0 1 0-.266-2.264c-2.904.344-5.78.578-8.688.838a1.143 1.143 0 0 0-1.035 1.236 1.143 1.143 0 0 0 1.24 1.036Z" className="fill-foreground"></path></svg>
          <div className='w-full py-5 px-4 flex gap-2'>
            <div className='w-3 h-3 rounded-full bg-red-400'></div>
            <div className='w-3 h-3 rounded-full bg-yellow-400'></div>
            <div className='w-3 h-3 rounded-full bg-lime-400'></div>
          </div>
          <div className="p-0 border-t-[1px] border-foreground/10">
            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713545055259" class="w-full rounded-b-2xl h-auto" alt="app demo" />
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Features Makeweb",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl grid grid-cols-5 gap-2">
          <div className="col-span-3 bg-lime-700 h-5 rounded"></div>
          <div className="col-span-2 bg-zinc-700 h-5 rounded"></div>
          <div className="col-span-2 bg-zinc-700 h-5 rounded"></div>
          <div className="col-span-3 bg-zinc-700 h-5 rounded"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Features Makeweb
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" className="w-full bg-background text-foreground font-body flex flex-col items-center gap-4 py-20 px-6 sm:px-12 md:px-20">
      <div className="w-full flex flex-col items-center gap-7">
        <div data-aos="fade-up" className='w-full flex flex-col items-center gap-16'>
          <div className='border border-primary text-primary py-[4px] px-6 text-[14px] rounded-full tracking-wide'>Features</div>
          <div className='text-5xl font-semibold text-center font-heading'>We have everything you would wish.</div>
          <Link to="/"><button aria-label="Get Started with Makeweb.ai" className="bg-primary text-white text-lg font-semibold px-10 py-[12px] rounded-full hover:bg-primary duration-200 flex gap-2 items-center">
            Get Started
          </button></Link>
          <div className='w-full grid grid-cols-12 gap-6'>
            <div className='h-72 sm:h-80 col-span-12 sm:col-span-7 bg-gradient-to-r  from-primary/50 to-primary/10 rounded-2xl py-8 pl-8 overflow-hidden'>
              <div className='space-y-2'>
                <p className='text-xl text-foreground/80 font-semibold font-heading'>AI Powered UI Builder</p>
                <p className='text-base text-foreground/60'>Built on top of OpenAI's GPT-4, it can build any kind of UI components from scratch.</p>
                <div className='pt-2 sm:pt-5'>
                 <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713545055259" loading='lazy' alt="AI powered website builder" className='rounded-2xl scale-110 md:w-5/6 ml-8 md:ml-24'/>
                </div>
              </div>
            </div>
            <div className='h-80 col-span-12 sm:col-span-5 border border-foreground/20 rounded-2xl py-9 px-8 sm:px-12 sm:overflow-scroll'>
              <div className='flex flex-col gap-6 sm:gap-8 text-foreground justify-center'>
                <p className='text-xl text-foreground/90 font-semibold mb-0 font-heading'>AI Capabilities</p>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>Text prompts to UI components.</span>
                </div>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>UI Screenshots to Editable Components.</span>
                </div>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>Select and update any components with AI.</span>
                </div>
              </div>
            </div>
            <div className='h-80 col-span-12 sm:col-span-5 border border-foreground/20 rounded-2xl py-9 px-8 sm:px-12 sm:overflow-scroll'>
              <div className='flex flex-col gap-6 sm:gap-8 text-foreground '>
                <p className='text-xl text-foreground/90 font-semibold mb-0 font-heading'>Builder Capabilities</p>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>Tons of responsive UI Blocks & Templates.</span>
                </div>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>Page Theme control.</span>
                </div>
                <div className='text-base text-foreground/80 flex gap-3 items-start'>
                  ${toStr(<IoCheckmark className="w-5 h-auto text-primary" />)}
                  <span className='w-5/6'>One-click publish with automated hosting.</span>
                </div>
              </div>
            </div>
            <div className='h-72 sm:h-80 col-span-12 sm:col-span-7 bg-gradient-to-r  from-primary/30 to-primary/10 rounded-2xl py-8 pl-8 overflow-hidden'>
              <div className='space-y-2'>
                <p className='text-xl text-foreground/80 font-semibold font-heading'>Drag & Drop UI Builder</p>
                <p className='text-base text-foreground/60'>Enriched with tons of UI Components and Templates</p>
                <div className='pt-8 sm:pt-6'>
                <img loading='lazy' src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713545055259" alt="Drag and Drop website builder" className='rounded-2xl scale-125 sm:scale-125 md:scale-100 ml-12 sm:ml-12 border border-foreground/30'/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Pricing",
    categ: ["sections", "pricing"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-2">
          <div className="bg-zinc-700 h-14 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 border-2 border-lime-600 h-14 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-lime-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 h-14 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Pricing Makeweb
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="pricing" class="w-screen bg-background text-foreground font-body flex flex-col items-center gap-4 py-20 px-6 sm:px-12 md:px-20">
        <div class="w-full flex flex-col items-center gap-7">
          <div data-aos="fade-up" class="flex flex-col items-center gap-12">
            <div class="border border-primary text-foreground/80 py-1 px-8 text-sm rounded-full tracking-wide font-semibold">Pricing</div>
            <div class="text-4xl text-center font-semibold text-foreground w-full md:w-600 lg:w-900 font-heading">Powerful tech at reasonable pricing.</div>
            <h2 class="text-lg sm:text-md font-semibold text-foreground w-full md:w-680 tracking-wider text-center font-body flex gap-1 justify-center items-center">
              <span class="animate-pulse text-primary">70% Off</span> for early adopters (11 Left)
            </h2>
          </div>
          <div data-aos="fade-up" class="flex justify-center flex-col md:flex-row w-full my-10 gap-16 md:gap-6 lg:gap-8 xl:gap-10">
            <div class="border border-foreground/10 bg-foreground/5 p-10 pb-6 rounded-2xl w-full sm:w-300 md:w-500 flex flex-col gap-5">
              <div>
                <p class="text-3xl font-bold">Basic</p>
                <p class="text-sm text-foreground/80">For individuals just starting up</p>
              </div>
              <div>
                <span class="text-5xl font-semibold">
                  <span class="line-through text-foreground/80 font-light mr-1 text-3xl">$30</span>
                  $21
                </span>
                <span class="font-semibold text-primary"> per year</span>
              </div>
              <div class="border-b border-foreground/10"></div>
              <div class="flex flex-col gap-3 text-base text-foreground font-semibold">
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Publish up to 1 site</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> 100 AI Prompts / mo</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Drag & Drop Builder</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Templates & UI Blocks</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Connect your own domain</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Free SSL Certificates</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Chat Support</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-foreground/80">✘</span> Export Your Code</div>
              </div>
              <a href="" target="_blank" rel="noreferrer" aria-label="Purchase Makeweb.ai Subscription" class="w-full justify-self-end py-3 rounded-xl bg-primary hover:bg-primary/80 duration-200 font-semibold flex justify-center text-lg text-white">Get This Plan</a>
            </div>

            <div class="relative border border-primary/50 bg-primary/10 p-10 pb-8 rounded-2xl w-full sm:w-300 md:w-500 flex flex-col gap-5">
              <div class="w-full text-center absolute top-[-12px] left-0"><span class="bg-primary text-foreground font-semibold px-4 py-1 text-sm rounded-full">Recommended</span></div>
              <div>
                <p class="text-3xl font-bold">Pro</p>
                <p class="text-sm text-foreground/80">For individuals, business owners</p>
              </div>
              <div>
                <span class="text-5xl font-semibold tracking-tighter">
                  <span class="line-through text-foreground/80 font-light mr-1 text-3xl">$99</span>
                  $29
                </span>
                <span class="font-semibold text-primary"> per year</span>
              </div>
              <div class="border-b border-foreground/10"></div>
              <div class="flex flex-col gap-3 text-base text-foreground font-semibold">
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Publish up to 10 sites</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Unlimited AI Prompts</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Drag & Drop Builder</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Templates & UI Blocks</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Connect your own domain</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Free SSL Certificates</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Email & Chat Support</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Export Your Code</div>
              </div>
              <a href="" target="_blank" rel="noreferrer" aria-label="Purchase Makeweb.ai Subscription" class="w-full py-3 text-lg rounded-xl bg-primary font-semibold hover:bg-primary/80 duration-200 flex justify-center text-white">Get This Plan</a>
            </div>

            <div class="border border-foreground/10 bg-foreground/5 p-10 pb-6 rounded-2xl w-full sm:w-300 md:w-500 flex flex-col gap-5">
              <div>
                <p class="text-3xl font-bold">Enterprise</p>
                <p class="text-sm text-foreground/80">For large busienss</p>
              </div>
              <div>
                <span class="text-5xl font-semibold">
                  <span class="line-through text-foreground/80 font-light mr-1 text-3xl">$30</span>
                  $99
                </span>
                <span class="font-semibold text-primary"> per year</span>
              </div>
              <div class="border-b border-foreground/10"></div>
              <div class="flex flex-col gap-3 text-base text-foreground font-semibold">
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Publish up to 1 site</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> 100 AI Prompts / mo</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Drag & Drop Builder</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Templates & UI Blocks</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Connect your own domain</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Free SSL Certificates</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-primary">✔</span> Chat Support</div>
                <div class="flex gap-3 items-center"><span class="w-5 h-auto text-foreground/80">✘</span> Export Your Code</div>
              </div>
              <a href="" target="_blank" rel="noreferrer" aria-label="Purchase Makeweb.ai Subscription" class="w-full justify-self-end py-3 rounded-xl bg-primary hover:bg-primary/80 duration-200 font-semibold flex justify-center text-lg text-white">Get This Plan</a>
            </div>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Pricing Grid",
    categ: ["sections", "pricing"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-2">
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Pricing Grid
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="pricing" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10">
        <div class="max-w-[85rem] mx-auto">
          <!-- Title -->
          <div data-aos="fade-up" class="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
            <h2 class="text-2xl font-bold md:text-4xl md:leading-tight text-foreground">Choose the Perfect Plan for Your Team</h2>
            <p class="mt-1 text-foreground/80">Flexible pricing options to fit your needs. Cancel anytime.</p>
          </div>
          <!-- End Title -->

          <!-- Grid -->
          <div data-aos="fade-up" class="relative before:absolute before:inset-0 before:-z-[1] before:bg-[radial-gradient(closest-side,var(--tw-color-foreground/10),transparent)] dark:before:bg-[radial-gradient(closest-side,var(--tw-color-background),transparent)] mt-12">
            <div class="grid gap-px sm:grid-cols-2 lg:grid-cols-4 lg:items-center">
              <!-- Card -->
              <div class="flex flex-col h-full text-center">
                <div class="bg-background pt-8 pb-5 px-8">
                  <h4 class="font-medium text-lg text-foreground">Free</h4>
                </div>

                <div class="h-full bg-background lg:mt-px lg:py-5 px-8">
                  <span class="mt-7 font-bold text-5xl text-foreground">
                    Free
                  </span>
                </div>

                <div class="bg-background flex justify-center lg:mt-px pt-7 px-8">
                  <ul class="space-y-2.5 text-center text-sm">
                    <li class="text-foreground/80">
                      1 user
                    </li>
                    <li class="text-foreground/80">
                      Basic features
                    </li>
                    <li class="text-foreground/80">
                      Limited support
                    </li>
                  </ul>
                </div>

                <div class="bg-background py-8 px-8">
                  <a class="py-3 px-4 w-full inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-primary text-primary hover:border-primary/80 hover:text-primary/80 disabled:opacity-50 disabled:pointer-events-none" href="#">
                    Sign Up
                  </a>
                </div>
              </div>
              <!-- End Card -->

              <!-- Card -->
              <div class="flex flex-col h-full text-center">
                <div class="bg-background pt-8 pb-5 px-8">
                  <h4 class="font-medium text-lg text-foreground">Startup</h4>
                </div>

                <div class="h-full bg-background lg:mt-px lg:py-5 px-8">
                  <span class="mt-7 font-bold text-5xl text-foreground">
                    <span class="font-bold text-2xl -me-2">$</span>
                    39
                  </span>
                </div>

                <div class="bg-background flex justify-center lg:mt-px pt-7 px-8">
                  <ul class="space-y-2.5 text-center text-sm">
                    <li class="text-foreground/80">
                      2 users
                    </li>
                    <li class="text-foreground/80">
                      Standard features
                    </li>
                    <li class="text-foreground/80">
                      Priority support
                    </li>
                  </ul>
                </div>

                <div class="bg-background py-8 px-8">
                  <a class="py-3 px-4 w-full inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-primary text-primary hover:border-primary/80 hover:text-primary/80 disabled:opacity-50 disabled:pointer-events-none" href="#">
                    Sign Up
                  </a>
                </div>
              </div>
              <!-- End Card -->

              <!-- Card -->
              <div class="flex flex-col h-full text-center">
                <div class="bg-background pt-8 pb-5 px-8">
                  <h4 class="font-medium text-lg text-foreground">Team</h4>
                </div>

                <div class="h-full bg-background lg:mt-px lg:py-5 px-8">
                  <span class="mt-7 font-bold text-5xl text-foreground">
                    <span class="font-bold text-2xl -me-2">$</span>
                    89
                  </span>
                </div>

                <div class="bg-background flex justify-center lg:mt-px pt-7 px-8">
                  <ul class="space-y-2.5 text-center text-sm">
                    <li class="text-foreground/80">
                      5 users
                    </li>
                    <li class="text-foreground/80">
                      All features
                    </li>
                    <li class="text-foreground/80">
                      24/7 support
                    </li>
                  </ul>
                </div>

                <div class="bg-background py-8 px-8">
                  <a class="py-3 px-4 w-full inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-primary text-primary hover:border-primary/80 hover:text-primary/80 disabled:opacity-50 disabled:pointer-events-none" href="#">
                    Sign Up
                  </a>
                </div>
              </div>
              <!-- End Card -->

              <!-- Card -->
              <div class="flex flex-col h-full text-center">
                <div class="bg-background pt-8 pb-5 px-8">
                  <h4 class="font-medium text-lg text-foreground">Enterprise</h4>
                </div>

                <div class="h-full bg-background lg:mt-px lg:py-5 px-8">
                  <span class="mt-7 font-bold text-5xl text-foreground">
                    <span class="font-bold text-2xl -me-2">$</span>
                    149
                  </span>
                </div>

                <div class="bg-background flex justify-center lg:mt-px pt-7 px-8">
                  <ul class="space-y-2.5 text-center text-sm">
                    <li class="text-foreground/80">
                      10 users
                    </li>
                    <li class="text-foreground/80">
                      Advanced features
                    </li>
                    <li class="text-foreground/80">
                      Dedicated support
                    </li>
                  </ul>
                </div>

                <div class="bg-background py-8 px-8">
                  <a class="py-3 px-4 w-full inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-primary text-primary hover:border-primary/80 hover:text-primary/80 disabled:opacity-50 disabled:pointer-events-none" href="#">
                    Sign Up
                  </a>
                </div>
              </div>
              <!-- End Card -->
            </div>
          </div>
          <!-- End Grid -->
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Pricing Two",
    categ: ["sections", "pricing"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-2">
          <div className="bg-zinc-700 h-14 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 border-2 border-lime-600 h-14 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-lime-600 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Pricing Two Cards
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="pricing" class="overflow-hidden bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10">
        <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
          <!-- Title -->
          <div data-aos="fade-up" class="mx-auto max-w-2xl mb-8 lg:mb-14 text-center">
            <h2 class="text-3xl lg:text-4xl font-bold text-foreground">
              Solo, agency, or team? We’ve got you covered.
            </h2>
          </div>
          <!-- End Title -->
      
          <div data-aos="fade-up" class="relative xl:w-10/12 xl:mx-auto">
            <!-- Grid -->
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
              <div>
                <!-- Card -->
                <div class="p-4 relative z-10 bg-background border rounded-xl md:p-10">
                  <h3 class="text-xl font-bold text-foreground">Professional</h3>
                  <div class="text-sm text-foreground/80">Everything a small team needs.</div>
      
                  <div class="mt-5">
                    <span class="text-6xl font-bold text-foreground">$18</span>
                    <span class="text-lg font-bold text-foreground">.00</span>
                    <span class="ms-3 text-foreground/80">USD / monthly</span>
                  </div>
      
                  <div class="mt-5 grid sm:grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0">
                    <!-- List -->
                    <ul class="space-y-2 text-sm sm:text-base">
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Up to 10 people
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Collect data
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Code extensibility
                        </span>
                      </li>
                    </ul>
                    <!-- End List -->
      
                    <!-- List -->
                    <ul class="space-y-2 text-sm sm:text-base">
                      <li class="flex space-x-3">
                        <span class="size-5 flex justify-center items-center rounded-full bg-foreground/10 text-foreground/60">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Custom reports
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="size-5 flex justify-center items-center rounded-full bg-foreground/10 text-foreground/60">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Product support
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="size-5 flex justify-center items-center rounded-full bg-foreground/10 text-foreground/60">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Activity reporting
                        </span>
                      </li>
                    </ul>
                    <!-- End List -->
                  </div>
      
                  <div class="mt-5 grid grid-cols-2 gap-x-4 py-4 first:pt-0 last:pb-0">
                    <div>
                      <p class="text-sm text-foreground/80">Cancel anytime.</p>
                      <p class="text-sm text-foreground/80">No card required.</p>
                    </div>
      
                    <div class="flex justify-end">
                      <button type="button" class="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-foreground/20 bg-background text-foreground shadow-sm hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none">Start free trial</button>
                    </div>
                  </div>
                </div>
                <!-- End Card -->
              </div>
      
              <div>
                <!-- Card -->
                <div class="shadow-xl shadow-primary/20 p-5 relative z-10 bg-background border rounded-xl md:p-10">
                  <h3 class="text-xl font-bold text-foreground">Teams</h3>
                  <div class="text-sm text-foreground/80">For growing businesses.</div>
                  <span class="absolute top-0 end-0 rounded-se-xl rounded-es-xl text-xs font-medium bg-foreground text-background py-1.5 px-3">Most popular</span>
      
                  <div class="mt-5">
                    <span class="text-6xl font-bold text-foreground">$36</span>
                    <span class="text-lg font-bold text-foreground">.99</span>
                    <span class="ms-3 text-foreground/80">USD / monthly</span>
                  </div>
      
                  <div class="mt-5 grid sm:grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0">
                    <!-- List -->
                    <ul class="space-y-2 text-sm sm:text-base">
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Up to 10 people
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Collect data
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Code extensibility
                        </span>
                      </li>
                    </ul>
                    <!-- End List -->
      
                    <!-- List -->
                    <ul class="space-y-2 text-sm sm:text-base">
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Custom reports
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Product support
                        </span>
                      </li>
      
                      <li class="flex space-x-3">
                        <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary/10 text-primary">
                          <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                        <span class="text-foreground">
                          Activity reporting
                        </span>
                      </li>
                    </ul>
                    <!-- End List -->
                  </div>
      
                  <div class="mt-5 grid grid-cols-2 gap-x-4 py-4 first:pt-0 last:pb-0">
                    <div>
                      <p class="text-sm text-foreground/80">Cancel anytime.</p>
                      <p class="text-sm text-foreground/80">No card required.</p>
                    </div>
      
                    <div class="flex justify-end">
                      <button type="button" class="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-primary text-background hover:bg-primary/80 disabled:opacity-50 disabled:pointer-events-none">Start free trial</button>
                    </div>
                  </div>
                </div>
                <!-- End Card -->
              </div>
            </div>
            <!-- End Grid -->
      
            <!-- SVG Element -->
            <div class="hidden md:block absolute top-0 end-0 translate-y-16 translate-x-16">
              <svg class="w-16 h-auto text-primary" width="121" height="135" viewBox="0 0 121 135" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 16.4754C11.7688 27.4499 21.2452 57.3224 5 89.0164" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
                <path d="M33.6761 112.104C44.6984 98.1239 74.2618 57.6776 83.4821 5" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
                <path d="M50.5525 130C68.2064 127.495 110.731 117.541 116 78.0874" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
              </svg>
            </div>
            <!-- End SVG Element -->
      
            <!-- SVG Element -->
            <div class="hidden md:block absolute bottom-0 start-0 translate-y-16 -translate-x-16">
              <svg class="w-56 h-auto text-primary" width="347" height="188" viewBox="0 0 347 188" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 82.4591C54.7956 92.8751 30.9771 162.782 68.2065 181.385C112.642 203.59 127.943 78.57 122.161 25.5053C120.504 2.2376 93.4028 -8.11128 89.7468 25.5053C85.8633 61.2125 130.186 199.678 180.982 146.248L214.898 107.02C224.322 95.4118 242.9 79.2851 258.6 107.02C274.299 134.754 299.315 125.589 309.861 117.539L343 93.4426" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
              </svg>
            </div>
            <!-- End SVG Element -->
          </div>
      
          <div class="mt-7 text-center">
            <p class="text-xs text-foreground/80">
              Prices in USD. Taxes may apply.
            </p>
          </div>
        </div>
      </section>      
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "FAQs",
    categ: ["sections", "faqs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex flex-col gap-2">
          <div className="w-full flex justify-between gap-2">
            <div className="w-20 h-2 rounded-full bg-zinc-700"></div>
            <FaAngleDown className="w-2 h-auto text-zinc-500" />
          </div>
          <div className="w-full flex gap-2">
            <div className="w-2 h-2 rounded-full bg-zinc-700"></div>
            <div className="w-28 h-2 rounded-full bg-zinc-700"></div>
          </div>
          <div className="w-full flex justify-between gap-2">
            <div className="w-20 h-2 rounded-full bg-zinc-700"></div>
            <FaAngleDown className="w-2 h-auto text-zinc-500" />
          </div>
          <div className="w-full flex gap-2">
            <div className="w-2 h-2 rounded-full bg-zinc-700"></div>
            <div className="w-28 h-2 rounded-full bg-zinc-700"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">FAQs</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="faqs" className='bg-background text-foreground font-body py-20 px-10 md:px-28 w-screen'>
        <div data-aos="fade-up" className="w-full flex flex-col items-center gap-16">
          <div className='border border-primary text-primary py-[4px] px-6 text-[14px] rounded-full tracking-wide'>FAQs</div>
          <div className='text-5xl font-semibold text-center font-heading'>Frequently Asked Questions.</div>
          <div className="flex flex-col space-y-2 p-4 w-full items-center">
            <details className="border-b border-grayshade-700 w-full md:w-[650px] lg:w-[800px] p-4">
              <summary className="cursor-pointer py-2 outline-none flex justify-between items-center" style={{ listStyle: 'none' }}>
                <span className='w-[90%]'>Does makeweb.ai take images as input?</span>
                ${toStr(
                  <FaAngleDown className="w-5 h-auto text-grayshade-300" />
                )}
              </summary>
              <p className="p-4">
                Yes, Makeweb.ai take images as input and converts them to close looking editable UI components.
              </p>
            </details>
            <details className="border-b border-grayshade-700 w-full md:w-[650px] lg:w-[800px] p-4">
              <summary className="cursor-pointer py-2 outline-none flex justify-between items-center" style={{ listStyle: 'none' }}>
                <span className='w-[90%]'>What is the core tech stack makeweb.ai uses under the hood to build webpages?</span>
                ${toStr(
                  <FaAngleDown className="w-5 h-auto text-grayshade-300" />
                )}
              </summary>
              <p className="p-4">
                Makeweb builds components using HTML, TailwindCSS, Vanila CSS and Javascript.
              </p>
            </details>
          </div>
        </div>
    </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Footer Standard",
    categ: ["sections", "footer"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-lg flex justify-between gap-5 h-fit">
          <div className="flex-1 flex flex-col gap-1 h-full justify-start">
            <div className="w-full rounded-full bg-lime-600 h-2"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <div className="w-full rounded-full bg-zinc-300 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <div className="w-full rounded-full bg-zinc-300 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <div className="w-full rounded-full bg-zinc-300 h-1"></div>
            <div className="w-full rounded-full bg-zinc-600 h-1"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Footer Makeweb
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="footer" className="w-screen bg-background text-foreground font-body px-6 sm:px-12 md:px-20 py-20">
        <div data-aos="fade-up" className='flex flex-col md:flex-row gap-16 lg:gap-36 w-full'>
          <div className='flex flex-col gap-6 w-72'>
            <a href="/" className='flex items-center gap-2 text-2xl font-webstitch font-medium'><img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-6606f89c6bf67ea5682f1bd3/image-1711813970238" alt="Logo of Company" className='h-9'/>BrandName</a>
            <p className='text-sm opacity-80'>Use text or image prompts to build websites with AI. Publish in one-click.</p>
            <p className='text-sm opacity-80'>All Rights Reserved. © ${new Date().getFullYear()}</p>
          </div>
          <div className='flex flex-col gap-2 text-base'>
            <p className=' text-base font-semibold mb-2'>Product</p>
            <a className='opacity-80 hover:opacity-100 duration-200' href='#features' aria-label="Features">Features</a>
            <a className='opacity-80 hover:opacity-100 duration-200' href='#pricing'>Pricing</a>
            
            <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='/about' aria-label="About">About</a>
            <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='/blog' aria-label="Blog">Blog</a>
          </div>
          <div className='flex flex-col gap-2 text-base'>
            <p className='text-base text-foreground font-semibold mb-2'>Support</p>
            <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='/privacy-policy' aria-label="Privacy Policys">Privacy Policy</a>
            <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='/terms-and-conditions' aria-label="Terms of Services">Terms of Services</a>
            <a className='opacity-80 hover:opacity-100 duration-200' href='#faqs' aria-label="Frequesntly Asked Questions">FAQs</a>
            <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='/docs' aria-label="Documentation">Documentation</a>
          </div>
          <div className='flex flex-col gap-2 text-base'>
            <p className='text-base text-foreground font-semibold mb-2'>Social</p>
            <div className='flex gap-5'>
              <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='https://twitter.com/zishansami102' aria-label="Twitter Link" rel="nofollow">${toStr(
                <FaXTwitter target="_blank" className="w-5 h-auto" />
              )} </a>
              <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='https://www.linkedin.com/in/zs102/' aria-label="Linked Page" rel="nofollow">${toStr(
                <FaLinkedin className="w-5 h-auto" />
              )} </a>
              <a className='opacity-80 hover:opacity-100 duration-200' target='_blank' href='https://www.instagram.com/' aria-label="Instagram Page" rel="nofollow">${toStr(
                <FaInstagram className="w-5 h-auto" />
              )} </a>
            </div>
            
          </div>
        </div>
        <div className='w-full border-b border-grayshade-900 mt-10'></div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Portfolio Hero",
    categ: ["sections", "portfolio", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex flex-col justify-between gap-5 h-fit">
          <div className="w-full flex justify-between px-3">
            <div className="w-4 h-2 bg-zinc-600 rounded-full"></div>
            <div className="w-4 h-2 bg-lime-600 rounded-full"></div>
          </div>
          <div className="w-full flex flex-col gap-2 items-center justify-center p-2">
            <div className="w-10 h-3 rounded-full bg-lime-600"></div>
            <div className="w-14 h-1 rounded-full bg-zinc-600"></div>
            <div className="w-14 h-1 rounded-full bg-zinc-600"></div>
            <FaUserCircle className="w-10 h-10 text-lime-600 mt-4"></FaUserCircle>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Portfolio Hero
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section data-aos="fade-up" className="min-h-screen w-screen bg-background text-foreground font-body px-16 md:px-20 lg:px-40">
          <nav className="py-10 mb-12 flex justify-between ">
            <h1 className="text-xl">smith_john</h1>
            <ul className="flex items-center">
              <li>
                <a
                  className="bg-gradient-to-r from-primary to-grayshade-500 text-white px-4 py-2 border-none rounded-md ml-8"
                  href="#"
                >
                  Resume
                </a>
              </li>
            </ul>
          </nav>
          <div className="text-center flex flex-col items-center py-10">
            <h2 className="text-5xl py-2 text-primary font-medium font-heading md:text-6xl">
              John Smith
            </h2>
            <h3 className="text-2xl py-2 md:text-3xl">
              Developer and designer.
            </h3>
            <p className="text-md py-5 leading-8 text-grayshade-600 max-w-xl mx-auto md:text-xl">
              Freelancer providing services for programming and design content
              needs. Join me down below and let's get cracking!
            </p>
            <div className="text-5xl flex justify-center gap-16 py-3 text-grayshade-500">
            ${toStr(<AiFillTwitterCircle className="h-10 w-auto" />)}
            ${toStr(<AiFillLinkedin className="h-10 w-auto" />)}
            ${toStr(<AiFillGithub className="h-10 w-auto" />)}
            </div>
            <div className="mx-auto bg-gradient-to-b from-primary rounded-full w-64 h-64 relative overflow-hidden mt-20 md:h-80 md:w-80">
              <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713036993985" layout="fill" objectFit="cover" className="object-cover w-full h-full" />
            </div>
          </div>
        </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Portfolio Services",
    categ: ["sections", "portfolio", "services"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full px-8 py-3 bg-zinc-800 rounded-xl flex gap-2">
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-1 justify-between text-zinc-300"></div>
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-1 justify-between text-zinc-300"></div>
          <div className="bg-zinc-700 h-10 rounded-lg flex-1 flex flex-col p-1 justify-between text-zinc-300"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Portfolio Services
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section data-aos="fade-up" className="w-screen bg-background text-foreground font-body px-16 md:px-20 lg:px-40">
          <div>
            <h3 className="text-3xl py-1 font-heading">Services I offer</h3>
            <p className="text-md py-2 leading-8 text-grayshade-600">
              Since the beginning of my journey as a freelance designer and
              developer, I've done remote work for 
              <span className="text-primary"> agencies </span> 
              consulted for <span className="text-primary"> startups </span>
              and collaborated with talanted people to create digital products
              for both business and consumer use.
            </p>
            <p className="text-md py-2 leading-8 text-grayshade-600">
              I offer from a wide range of services, including brand design,
              programming and teaching.
            </p>
          </div>
          <div data-aos="fade-up"  className="lg:flex gap-10">
            <div className="text-center flex-1 flex flex-col items-center shadow-lg p-10 rounded-xl my-10">
              <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037406268" className="w-28 h-28" />
              <h3 className="text-lg font-medium pt-8 pb-2  ">
                Beautiful Designs
              </h3>
              <p className="py-2">
                Creating elegant designs suited for your needs following core
                design theory.
              </p>
              <h4 className="py-4 text-primary">Design Tools I Use</h4>
              <p className="text-grayshade-600 py-1">Photoshop</p>
              <p className="text-grayshade-600 py-1">Illustrator</p>
              <p className="text-grayshade-600 py-1">Figma</p>
              <p className="text-grayshade-600 py-1">Indesign</p>
            </div>
            <div className="text-center flex-1 flex flex-col items-center  shadow-lg p-10 rounded-xl my-10">
              <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037571978" className="w-28 h-28" />
              <h3 className="text-lg font-medium pt-8 pb-2 ">
                Code your dream project
              </h3>
              <p className="py-2">
                Do you have an idea for your next great website? Let's make it a
                reality.
              </p>
              <h4 className="py-4 text-primary">Design Tools I Use</h4>
              <p className="text-grayshade-600 py-1">Photoshop</p>
              <p className="text-grayshade-600 py-1">Illustrator</p>
              <p className="text-grayshade-600 py-1">Figma</p>
              <p className="text-grayshade-600 py-1">Indesign</p>
            </div>
            <div className="text-center flex-1 flex flex-col items-center  shadow-lg p-10 rounded-xl my-10">
            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037584070" className="w-28 h-28" />
              <h3 className="text-lg font-medium pt-8 pb-2 ">Consulting</h3>
              <p className="py-2">
                Are you interested in feedback for your current project? I can
                give you tips and tricks to level it up.
              </p>
              <h4 className="py-4 text-primary">Design Tools I Use</h4>
              <p className="text-grayshade-600 py-1">Photoshop</p>
              <p className="text-grayshade-600 py-1">Illustrator</p>
              <p className="text-grayshade-600 py-1">Figma</p>
              <p className="text-grayshade-600 py-1">Indesign</p>
            </div>
          </div>
        </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Portfolio Projects",
    categ: ["sections", "portfolio", "gallery", "projects"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full py-3 bg-zinc-800 rounded-lg flex flex-col items-center gap-5 h-fit">
          <div className="grid grid-cols-2 grid-rows-2 gap-2">
            <div className="w-10 h-10 rounded-lg bg-zinc-600"></div>
            <div className="w-10 h-10 rounded-lg bg-zinc-600"></div>
            <div className="w-10 h-10 rounded-lg bg-zinc-600"></div>
            <div className="w-10 h-10 rounded-lg bg-zinc-600"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Project Gallery
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section data-aos="fade-up" className="w-screen bg-background text-foreground font-body px-16 md:px-20 lg:px-40 py-10">
          <div>
            <h3 className="text-3xl py-1 font-heading">Projects</h3>
            <p className="text-md py-2 leading-8 text-grayshade-600">
              Since the beginning of my journey as a freelance designer and
              developer, I've done remote work for 
              <span className="text-primary"> agencies </span> 
              consulted for <span className="text-primary">startups </span>
               and collaborated with talanted people to create digital products
              for both business and consumer use.
            </p>
            <p className="text-md py-2 leading-8 text-grayshade-600">
              I offer from a wide range of services, including brand design,
              programming and teaching.
            </p>
          </div>
          <div data-aos="fade-up"  className="flex flex-col gap-10 py-10 lg:flex-row lg:flex-wrap">
            <div className="basis-1/3 flex-1 hover:scale-105 duration-200">
              <img
                className="rounded-lg object-cover w-[100%] h-[100%]"
                layout="responsive"
                src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037754715"
              />
            </div>
            <div className="basis-1/3 flex-1 hover:scale-105 duration-200">
              <img
                className="rounded-lg object-cover w-[100%] h-[100%]"
                layout="responsive"
                src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037860271"
              />
            </div>
            <div className="basis-1/3 flex-1 hover:scale-105 duration-200">
              <img
                className="rounded-lg object-cover w-[100%] h-[100%]"
                layout="responsive"
                src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713037943976"
              />
            </div>
            <div className="basis-1/3 flex-1 hover:scale-105 duration-200">
              <img
                className="rounded-lg object-cover w-[100%] h-[100%]"
                layout="responsive"
                src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-661add72416b5ad2aa108187/image-1713038106779"
              />
            </div>
          </div>
        </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Navbar Play",
    categ: ["sections", "navs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="rounded bg-zinc-100 w-3 h-3"></div>
          <div className="rounded bg-zinc-200 w-16 h-1"></div>
          <div className="flex gap-1">
            <div className="rounded bg-zinc-200 w-3 h-2"></div>
            <div className="rounded bg-zinc-200 w-3 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Navbar Transparent Play
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <nav
      class="bg-opacity-40 backdrop-blur-sm fixed top-0 left-0 z-40 w-full flex items-center justify-center"
    >
        <div class="flex px-6 sm:px-12 md:px-20 items-center justify-between relative w-full">
          <div class="w-60 max-w-full">
            <a href="/" class="w-full py-5 flex items-center gap-3 capitalize text-white font-semibold text-3xl">
              <img
                src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713539128214"
                alt="logo"
                class="capitalize text-grayshade-100 font-bold text-3xl w-10 h-10"
              />BrandName
            </a>
          </div>
          <div class="flex px-4 justify-between items-center w-fit">
            <div>
              <button
                id="navbarToggler"
                class="block absolute right-4 top-1/2 -translate-y-1/2 lg:hidden focus:ring-2 ring-primary px-3 py-[6px] rounded-lg"
              >
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
                <span
                  class="relative w-[30px] h-[2px] my-[6px] block bg-white"
                ></span>
              </button>
              <nav
                id="navbarCollapse"
                class="absolute py-5 lg:py-0 lg:px-4 xl:px-6 bg-background md:bg-transparent shadow-lg rounded-lg max-w-[250px] w-full lg:max-w-full lg:w-full right-4 top-full hidden lg:block lg:static lg:shadow-none"
              >
                <ul class="blcok lg:flex">
                  <li class="relative group">
                    <a
                      href="#home"
                      class="ud-menu-scroll text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0 flex mx-8 lg:mr-0 duration-300"
                    >
                      Home
                    </a>
                  </li>
                  <li class="relative group">
                    <a
                      href="#about"
                      class="ud-menu-scroll text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0 flex mx-8 lg:mr-0 lg:ml-7 xl:ml-12 duration-300"
                    >
                      About
                    </a>
                  </li>
                  <li class="relative group">
                    <a
                      href="#pricing"
                      class="ud-menu-scroll text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0 flex mx-8 lg:mr-0 lg:ml-7 xl:ml-12 duration-300"
                    >
                      Pricing
                    </a>
                  </li>
                  <li class="relative group">
                    <a
                      href="#team"
                      class="ud-menu-scroll text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0 flex mx-8 lg:mr-0 lg:ml-7 xl:ml-12 duration-300"
                    >
                      Team
                    </a>
                  </li>
                  <li class="relative group">
                    <a
                      href="#contact"
                      class="ud-menu-scroll text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0 flex mx-8 lg:mr-0 lg:ml-7 xl:ml-12 duration-300"
                    >
                      Contact
                    </a>
                  </li>
                  <li class="relative group submenu-item">
                    <a
                      href="/"
                      class="text-base text-foreground lg:text-white lg:group-hover:opacity-70 lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:pl-0 lg:pr-4 flex mx-8 lg:mr-0 lg:ml-8 xl:ml-12 relative after:absolute after:w-2 after:h-2 after:border-b-2 after:border-r-2 after:border-current after:rotate-45 lg:after:right-0 after:right-1 after:top-1/2 after:-translate-y-1/2 after:mt-[-2px] duration-300"
                    >
                      Pages
                    </a>
                    <div
                      class="submenu hidden relative lg:absolute w-[250px] top-full lg:top-[110%] left-0 rounded-sm lg:shadow-lg p-4 lg:block lg:opacity-0 lg:invisible group-hover:opacity-100 lg:group-hover:visible lg:group-hover:top-full bg-background transition-[top] duration-300"
                    >
                      <a
                        href="about.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4 duration-300"
                      >
                        About Page
                      </a>
                      <a
                        href="pricing.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4 duration-300"
                      >
                        Pricing Page
                      </a>
                      <a
                        href="contact.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4 duration-300"
                      >
                        Contact Page
                      </a>
                      <a
                        href="blog-grids.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4 duration-300"
                      >
                        Blog Grid Page
                      </a>
                      <a
                        href="blog-details.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4 duration-300"
                      >
                        Blog Details Page
                      </a>
                      <a
                        href="signup.html"
                        class="block text-sm text-foreground rounded hover:text-primary py-[10px] px-4"
                      >
                        Sign Up Page
                      </a>
                      <a
                        href="signin.html"
                        class="block text-sm text-foreground rounded hover:text-primary duration-300 py-[10px] px-4"
                      >
                        Sign In Page
                      </a>
                      <a
                        href="404.html"
                        class="block text-sm text-foreground rounded hover:text-primary duration-300 py-[10px] px-4"
                      >
                        404 Page
                      </a>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="sm:flex justify-end hidden pr-16 lg:pr-0">
            <a
              href="signin.html"
              class="text-base font-medium text-white hover:opacity-70 py-3 px-7 loginBtn"
            >
              Sign In
            </a>
            <a
              href="signup.html"
              class="text-base font-medium text-white bg-white bg-opacity-20 rounded-lg py-3 px-6 hover:bg-opacity-40 signUpBtn duration-300 ease-in-out"
            >
              Sign Up
            </a>
          </div>
        </nav>
      `;
      const script = `
      // ===== responsive navbar
      navbarToggler = document.querySelector("#navbarToggler");
      navbarCollapse = document.querySelector("#navbarCollapse");
    
      navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("navbarTogglerActive");
        navbarCollapse.classList.toggle("hidden");
      });
    
      //===== close navbar-collapse when a  clicked
      document
        .querySelectorAll("#navbarCollapse ul li:not(.submenu-item) a")
        .forEach((e) =>
          e.addEventListener("click", () => {
            navbarToggler.classList.remove("navbarTogglerActive");
            navbarCollapse.classList.add("hidden");
          })
        );
    
      // ===== Sub-menu
      const submenuItems = document.querySelectorAll(".submenu-item");
      submenuItems.forEach((el) => {
        el.querySelector("a").addEventListener("click", () => {
          el.querySelector(".submenu").classList.toggle("hidden");
        });
      });
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode), script };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Hero Play Primary",
    categ: ["sections", "hero"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 pb-0 bg-lime-600/20 rounded-lg flex justify-between items-center">
          <div className="flex-grow p-1 flex flex-col gap-2 items-center justify-center">
            <div className="bg-zinc-200 rounded-xl w-2/3 h-2"></div>
            <div className="bg-zinc-200 opacity-80 rounded-xl w-1/3 h-1"></div>
            <div className="bg-lime-200 rounded-xl w-1/4 h-1"></div>
            <div className="bg-zinc-200 rounded-t-md w-2/3 h-8"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Hero Play Primary</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section
        data-aos="fade-up" id="home"
        class="w-screen relative pt-[120px] md:pt-[130px] lg:pt-[160px] bg-primary flex justify-center items-center"
      >
          <div class="flex flex-wrap items-center -mx-4">
            <div class="w-full px-4">
              <div
                class="hero-content text-center max-w-[780px] mx-auto wow fadeInUp"
                data-wow-delay=".2s"
              >
                <h1
                  class="text-white font-bold font-heading text-3xl sm:text-4xl md:text-[45px] leading-snug sm:leading-snug md:leading-snug mb-8"
                >
                  Open-Source Web Template for SaaS, Startup, Apps, and More
                </h1>
                <p
                  class="text-base sm:text-lg sm:leading-relaxed md:text-xl md:leading-relaxed mx-auto mb-10 text-[#e4e4e4] max-w-[600px]"
                >
                  Multidisciplinary Web Template Built with Your Favourite Technology
                  - HTML Bootstrap, Tailwind and React NextJS.
                </p>
                <ul class="flex flex-wrap items-center justify-center mb-10">
                  <li>
                    <a
                      href="/"
                      class="py-4 px-6 sm:px-10 inline-flex items-center justify-center text-center text-black bg-white hover:text-primary hover:scale-105 hover:shadow-lg font-semibold rounded-lg transition duration-300 ease-in-out"
                    >
                      Download Now
                    </a>
                  </li>
                  <li>
                    <a
                      href="/"
                      target="_blank"
                      class="text-base font-medium text-white py-4 px-6 sm:px-10 flex items-center hover:opacity-70 transition duration-300 ease-in-out"
                    >
                      Star on Github
                      <span class="pl-2">
                        <svg
                          width="20"
                          height="8"
                          viewBox="0 0 20 8"
                          class="fill-current"
                        >
                          <path
                            d="M19.2188 2.90632L17.0625 0.343819C16.875 0.125069 16.5312 0.0938193 16.2812 0.281319C16.0625 0.468819 16.0312 0.812569 16.2188 1.06257L18.25 3.46882H0.9375C0.625 3.46882 0.375 3.71882 0.375 4.03132C0.375 4.34382 0.625 4.59382 0.9375 4.59382H18.25L16.2188 7.00007C16.0312 7.21882 16.0625 7.56257 16.2812 7.78132C16.375 7.87507 16.5 7.90632 16.625 7.90632C16.7812 7.90632 16.9375 7.84382 17.0312 7.71882L19.1875 5.15632C19.75 4.46882 19.75 3.53132 19.2188 2.90632Z"
                          />
                        </svg>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
      
            <div class="w-full px-4">
              <div
                class="mx-auto max-w-[845px] relative z-10 wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div class="mt-16">
                  <img
                    src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662286733640661696573cc3/image-1713545055259"
                    alt="hero"
                    class="max-w-full mx-auto rounded-t-xl rounded-tr-xl"
                  />
                </div>
                <div class="absolute z-[-1] bottom-0 -left-9">
                  <svg
                    width="134"
                    height="106"
                    viewBox="0 0 134 106"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.66667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 1.66667 104)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 16.3333 104)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 31 104)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 45.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 60.3333 104)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 88.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 117.667 104)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 74.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 103 104)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 132 104)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 1.66667 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 16.3333 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 31 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 45.6667 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 60.3333 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 88.6667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 117.667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 74.6667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 103 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 132 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="74.6673"
                      r="1.66667"
                      transform="rotate(-90 1.66667 74.6673)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 1.66667 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 16.3333 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 16.3333 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 31 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 31 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 45.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 45.6667 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 60.3333 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 60.3333 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 88.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 88.6667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 117.667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 117.667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 74.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 74.6667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 103 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 103 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 132 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 132 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 1.66667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 1.66667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 16.3333 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 16.3333 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 31 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 31 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 45.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 45.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 60.3333 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 60.3333 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 88.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 88.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 117.667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 117.667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 74.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 74.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 103 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 103 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 132 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 132 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 1.66667 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 1.66667 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 16.3333 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 16.3333 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 31 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 31 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 45.6667 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 45.6667 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 60.3333 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 60.3333 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 88.6667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 88.6667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 117.667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 117.667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 74.6667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 74.6667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 103 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 103 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 132 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 132 1.66707)"
                      fill="white"
                    />
                  </svg>
                </div>
                <div class="absolute z-[-1] -top-6 -right-6">
                  <svg
                    width="134"
                    height="106"
                    viewBox="0 0 134 106"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.66667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 1.66667 104)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 16.3333 104)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 31 104)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 45.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 60.3333 104)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 88.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 117.667 104)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 74.6667 104)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 103 104)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="104"
                      r="1.66667"
                      transform="rotate(-90 132 104)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 1.66667 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 16.3333 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 31 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="89.3333"
                      r="1.66667"
                      transform="rotate(-90 45.6667 89.3333)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 60.3333 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 88.6667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 117.667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 74.6667 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 103 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="89.3338"
                      r="1.66667"
                      transform="rotate(-90 132 89.3338)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="74.6673"
                      r="1.66667"
                      transform="rotate(-90 1.66667 74.6673)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 1.66667 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 16.3333 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 16.3333 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 31 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 31 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 45.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="31.0003"
                      r="1.66667"
                      transform="rotate(-90 45.6667 31.0003)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 60.3333 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 60.3333 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 88.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 88.6667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 117.667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 117.667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 74.6667 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 74.6667 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 103 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 103 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="74.6668"
                      r="1.66667"
                      transform="rotate(-90 132 74.6668)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="31.0001"
                      r="1.66667"
                      transform="rotate(-90 132 31.0001)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 1.66667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 1.66667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 16.3333 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 16.3333 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 31 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 31 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 45.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 45.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 60.3333 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 60.3333 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 88.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 88.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 117.667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 117.667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 74.6667 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 74.6667 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 103 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 103 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="60.0003"
                      r="1.66667"
                      transform="rotate(-90 132 60.0003)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="16.3336"
                      r="1.66667"
                      transform="rotate(-90 132 16.3336)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 1.66667 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="1.66667"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 1.66667 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 16.3333 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="16.3333"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 16.3333 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 31 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="31"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 31 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="45.3336"
                      r="1.66667"
                      transform="rotate(-90 45.6667 45.3336)"
                      fill="white"
                    />
                    <circle
                      cx="45.6667"
                      cy="1.66683"
                      r="1.66667"
                      transform="rotate(-90 45.6667 1.66683)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 60.3333 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="60.3333"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 60.3333 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 88.6667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="88.6667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 88.6667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 117.667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="117.667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 117.667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 74.6667 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="74.6667"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 74.6667 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 103 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="103"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 103 1.66707)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="45.3338"
                      r="1.66667"
                      transform="rotate(-90 132 45.3338)"
                      fill="white"
                    />
                    <circle
                      cx="132"
                      cy="1.66707"
                      r="1.66667"
                      transform="rotate(-90 132 1.66707)"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Features Play",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-4">
            <div className="rounded-md flex-1 flex flex-col items-center gap-2">
              <div className="bg-lime-600 h-3 w-3 rounded-md p-2"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2">
              <div className="bg-lime-600 h-3 w-3 rounded-md p-2"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2">
              <div className="bg-lime-600 h-3 w-3 rounded-md p-2"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2">
              <div className="bg-lime-600 h-3 w-3 rounded-md p-2"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Features Play</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" className="bg-background text-foreground font-body w-screen flex justify-center flex-col items-start gap-4 px-6 sm:px-12 md:px-20 pt-20 lg:pt-[120px] pb-8 lg:pb-[70px]">
        <div data-aos='fade-up' class="flex flex-wrap">
          <div class="w-full">
            <div class="mb-12 lg:mb-20 max-w-[620px]">
              <span class="font-bold text-lg text-primary mb-2 block">
                Features
              </span>
              <h2
                class="font-bold text-3xl sm:text-4xl md:text-[42px] mb-4 font-heading"
              >
                Main Features Of Play
              </h2>
              <p
                class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-foreground opacity-70"
              >
                There are many variations of passages of Lorem Ipsum available but
                the majority have suffered alteration in some form.
              </p>
            </div>
          </div>
        </div>
        <div data-aos='fade-up' class="flex flex-wrap -mx-4">
          <div class="w-full md:w-1/2 lg:w-1/4 p-4">
            <div class="mb-12 group wow fadeInUp" data-wow-delay=".3s">
              <div
                class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
              >
                <span
                  class="w-[70px] h-[70px] flex items-center justify-center bg-primary opacity-40 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                ></span>
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M44.9313 11.7H38.9188C40.5438 10.9687 41.7626 9.99374 42.2501 8.69374C42.9001 6.98749 42.2501 5.19999 40.3001 3.33124C38.1876 1.29999 35.9938 0.568738 33.8001 1.13749C29.9813 2.11249 27.4626 7.06874 26.2438 9.99374C25.1063 7.06874 22.5876 2.11249 18.6876 1.13749C16.4938 0.568738 14.3001 1.29999 12.1876 3.33124C10.2376 5.19999 9.5876 6.98749 10.2376 8.69374C10.7251 9.99374 12.0251 10.9687 13.5688 11.7H7.06885C5.0376 11.7 3.4126 13.325 3.4126 15.3562V21.5312C3.4126 23.5625 5.0376 25.1875 7.06885 25.1875H7.71885V46.2312C7.71885 48.8312 9.83135 51.025 12.5126 51.025H40.1376C42.7376 51.025 44.9313 48.9125 44.9313 46.2312V25.1875C46.9626 25.1875 48.5876 23.5625 48.5876 21.5312V15.3562C48.5063 13.325 46.8813 11.7 44.9313 11.7ZM34.5313 3.98124C34.7751 3.89999 35.0188 3.89999 35.1813 3.89999C36.1563 3.89999 37.2126 4.38749 38.2688 5.52499C38.7563 6.01249 39.8126 7.06874 39.5688 7.79999C39.0001 9.34374 33.9626 10.6437 28.9251 11.05C30.0626 8.36874 32.1751 4.54999 34.5313 3.98124ZM13.0001 7.71874C12.7563 6.98749 13.8126 5.93124 14.3001 5.44374C15.4376 4.38749 16.4126 3.81874 17.3876 3.81874C17.6313 3.81874 17.8751 3.81874 18.0376 3.89999C20.4751 4.54999 22.5063 8.28749 23.6438 10.9687C18.6063 10.5625 13.5688 9.26249 13.0001 7.71874ZM42.0063 46.2312C42.0063 47.2875 41.1126 48.1812 40.0563 48.1812H12.4313C11.3751 48.1812 10.4813 47.2875 10.4813 46.2312V25.1875H41.9251V46.2312H42.0063ZM45.6626 21.5312C45.6626 22.0187 45.3376 22.3437 44.8501 22.3437H7.06885C6.6626 22.3437 6.25635 22.0187 6.25635 21.5312V15.3562C6.25635 14.95 6.6626 14.5437 7.06885 14.5437H44.8501C45.2563 14.5437 45.6626 14.8687 45.6626 15.3562V21.5312Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h4 class="font-bold text-xl mb-3">Free and Open-Source</h4>
              <p class="text-foreground opacity-70 mb-8 lg:mb-11">
                Lorem Ipsum is simply dummy text of the printing and industry.
              </p>
              <a
                href="/"
                class="font-medium text-base text-foreground opacity-70 hover:text-primary"
              >
                Learn More
              </a>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 p-4 ">
            <div class=" mb-12 group wow fadeInUp" data-wow-delay=".15s">
              <div
                class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
              >
                <span
                  class="w-[70px] h-[70px] flex items-center justify-center bg-primary opacity-40 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                ></span>
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.8062 23.3187L43.875 17.3875C43.3063 16.8187 42.4125 16.8187 41.8438 17.3875C41.275 17.9562 41.275 18.85 41.8438 19.4187L46.9625 24.6187H27.4625V4.87498L32.5812 10.075C33.15 10.6437 34.0437 10.6437 34.6125 10.075C35.1812 9.50623 35.1812 8.61248 34.6125 8.04373L28.6812 2.11248C27.95 1.38123 26.975 0.974976 26 0.974976C24.9438 0.974976 24.05 1.38123 23.3188 2.11248L17.3875 8.04373C16.8187 8.61248 16.8187 9.50623 17.3875 10.075C17.6312 10.3187 18.0375 10.4812 18.3625 10.4812C18.6875 10.4812 19.0937 10.3187 19.3375 10.075L24.6187 4.87498V24.5375H4.95625L10.075 19.3375C10.6437 18.7687 10.6437 17.875 10.075 17.3062C9.50625 16.7375 8.6125 16.7375 8.04375 17.3062L2.1125 23.2375C0.65 24.7 0.65 27.1375 2.1125 28.6L8.04375 34.5312C8.2875 34.775 8.69375 34.9375 9.01875 34.9375C9.34375 34.9375 9.75 34.775 9.99375 34.5312C10.5625 33.9625 10.5625 33.0687 9.99375 32.5L4.79375 27.3H24.4563V47.125L19.2563 41.925C18.6875 41.3562 17.7938 41.3562 17.225 41.925C16.6563 42.4937 16.6563 43.3875 17.225 43.9562L23.1562 49.8875C23.8875 50.6187 24.8625 51.025 25.8375 51.025C26.8937 51.025 27.7875 50.6187 28.5187 49.8875L34.45 43.9562C35.0188 43.3875 35.0188 42.4937 34.45 41.925C33.8813 41.3562 32.9875 41.3562 32.4188 41.925L27.4625 47.125V27.3812H47.0438L41.8438 32.5812C41.275 33.15 41.275 34.0437 41.8438 34.6125C42.0875 34.8562 42.4938 35.0187 42.8188 35.0187C43.1438 35.0187 43.55 34.8562 43.7938 34.6125L49.725 28.6812C51.2688 27.2187 51.2687 24.7812 49.8062 23.3187Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h4 class="font-bold text-xl mb-3">
                Multipurpose Template
              </h4>
              <p class="text-foreground opacity-70 mb-8 lg:mb-11">
                Lorem Ipsum is simply dummy text of the printing and industry.
              </p>
              <a
                href="/"
                class="font-medium text-base text-foreground opacity-70 hover:text-primary"
              >
                Learn More
              </a>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 p-4">
            <div class="mb-12 group wow fadeInUp" data-wow-delay=".2s">
              <div
                class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
              >
                <span
                  class="w-[70px] h-[70px] flex items-center justify-center bg-primary opacity-40 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                ></span>
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7734 14.3281H3.82813C2.07813 14.3281 0.65625 12.9062 0.65625 11.1562V4.21094C0.65625 2.46094 2.07813 1.03906 3.82813 1.03906H10.7734C12.5234 1.03906 13.9453 2.46094 13.9453 4.21094V11.1562C13.9453 12.9062 12.5234 14.3281 10.7734 14.3281ZM3.82813 2.95312C3.17188 2.95312 2.57031 3.5 2.57031 4.21094V11.1562C2.57031 11.8125 3.11719 12.4141 3.82813 12.4141H10.7734C11.4297 12.4141 12.0313 11.8672 12.0313 11.1562V4.21094C12.0313 3.55469 11.4844 2.95312 10.7734 2.95312H3.82813Z"
                    fill="white"
                  />
                  <path
                    d="M31.1719 14.3281H24.2266C22.4766 14.3281 21.0547 12.9062 21.0547 11.1562V4.21094C21.0547 2.46094 22.4766 1.03906 24.2266 1.03906H31.1719C32.9219 1.03906 34.3438 2.46094 34.3438 4.21094V11.1562C34.3438 12.9062 32.9219 14.3281 31.1719 14.3281ZM24.2266 2.95312C23.5703 2.95312 22.9688 3.5 22.9688 4.21094V11.1562C22.9688 11.8125 23.5156 12.4141 24.2266 12.4141H31.1719C31.8281 12.4141 32.4297 11.8672 32.4297 11.1562V4.21094C32.4297 3.55469 31.8828 2.95312 31.1719 2.95312H24.2266Z"
                    fill="white"
                  />
                  <path
                    d="M10.7734 33.9609H3.82813C2.07813 33.9609 0.65625 32.5391 0.65625 30.7891V23.8438C0.65625 22.0938 2.07813 20.6719 3.82813 20.6719H10.7734C12.5234 20.6719 13.9453 22.0938 13.9453 23.8438V30.7891C13.9453 32.5391 12.5234 33.9609 10.7734 33.9609ZM3.82813 22.5859C3.17188 22.5859 2.57031 23.1328 2.57031 23.8438V30.7891C2.57031 31.4453 3.11719 32.0469 3.82813 32.0469H10.7734C11.4297 32.0469 12.0313 31.5 12.0313 30.7891V23.8438C12.0313 23.1875 11.4844 22.5859 10.7734 22.5859H3.82813Z"
                    fill="white"
                  />
                  <path
                    d="M31.1719 33.9609H24.2266C22.4766 33.9609 21.0547 32.5391 21.0547 30.7891V23.8438C21.0547 22.0938 22.4766 20.6719 24.2266 20.6719H31.1719C32.9219 20.6719 34.3438 22.0938 34.3438 23.8438V30.7891C34.3438 32.5391 32.9219 33.9609 31.1719 33.9609ZM24.2266 22.5859C23.5703 22.5859 22.9688 23.1328 22.9688 23.8438V30.7891C22.9688 31.4453 23.5156 32.0469 24.2266 32.0469H31.1719C31.8281 32.0469 32.4297 31.5 32.4297 30.7891V23.8438C32.4297 23.1875 31.8828 22.5859 31.1719 22.5859H24.2266Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h4 class="font-bold text-xl mb-3">High-quality Design</h4>
              <p class="text-foreground opacity-70 mb-8 lg:mb-11">
                Lorem Ipsum is simply dummy text of the printing and industry.
              </p>
              <a
                href="/"
                class="font-medium text-base text-foreground opacity-70 hover:text-primary"
              >
                Learn More
              </a>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 p-4">
            <div class="mb-12 group wow fadeInUp" data-wow-delay=".25s">
              <div
                class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
              >
                <span
                  class="w-[70px] h-[70px] flex items-center justify-center bg-primary opacity-40 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                ></span>
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.5312 21.6562L28.6563 21.1641L29.6953 20.5625C30.7344 19.9062 31.3359 18.8125 31.2812 17.6094C31.2266 16.4063 30.625 15.3125 29.5312 14.7109L27.8906 13.7813L29.6406 12.6875C30.6797 12.0313 31.2812 10.9375 31.2266 9.73438C31.1719 8.53125 30.5703 7.4375 29.4766 6.83594L19.25 1.09375C18.2109 0.492187 16.9531 0.546875 15.9141 1.09375L5.41406 7.21875C4.375 7.82031 3.71875 8.91406 3.71875 10.1172C3.71875 11.3203 4.375 12.4141 5.41406 13.0156L7.10938 14L5.41406 14.9844C4.375 15.5859 3.71875 16.6797 3.71875 17.8828C3.71875 19.0859 4.32031 20.1797 5.41406 20.7812L6.39844 21.3281L5.46875 21.875C4.42969 22.4766 3.77344 23.5703 3.77344 24.7734C3.77344 25.9766 4.375 27.0703 5.46875 27.6719L15.9141 33.6875C16.4609 34.0156 17.0078 34.125 17.6094 34.125C18.2109 34.125 18.8125 33.9609 19.3594 33.6328L29.6953 27.2891C30.7344 26.6328 31.3359 25.5391 31.2812 24.3359C31.2266 23.2969 30.625 22.2031 29.5312 21.6562ZM5.63281 10.1172C5.63281 9.57031 5.90625 9.13281 6.34375 8.85938L16.8438 2.78906C17.0625 2.67969 17.3359 2.57031 17.5547 2.57031C17.7734 2.57031 18.0469 2.625 18.2656 2.73437L28.5469 8.47656C28.9844 8.75 29.2578 9.1875 29.3125 9.73438C29.3125 10.2812 29.0391 10.7188 28.6016 10.9922L18.3203 17.3906C17.8828 17.6641 17.2812 17.6641 16.8438 17.3906L6.39844 11.375C5.90625 11.1562 5.63281 10.6641 5.63281 10.1172ZM5.63281 17.9375C5.63281 17.3906 5.90625 16.9531 6.34375 16.6797L9.02344 15.1484L15.8594 19.0859C16.4062 19.4141 16.9531 19.5234 17.5547 19.5234C18.1562 19.5234 18.7578 19.3594 19.3047 19.0312L26.0312 14.875L28.6016 16.2969C29.0391 16.5703 29.3125 17.0078 29.3672 17.5547C29.3672 18.1016 29.0938 18.5391 28.6563 18.8125L18.3203 25.2656C17.8828 25.5391 17.2812 25.5391 16.8438 25.2656L6.39844 19.25C5.90625 18.9766 5.63281 18.4844 5.63281 17.9375ZM28.6563 25.8125L18.3203 32.2109C17.8828 32.4844 17.2812 32.4844 16.8438 32.2109L6.39844 26.1953C5.96094 25.9219 5.6875 25.4844 5.6875 24.9375C5.6875 24.3906 5.96094 23.9531 6.39844 23.6797L8.3125 22.5859L15.8594 26.9609C16.4062 27.2891 16.9531 27.3984 17.5547 27.3984C18.1562 27.3984 18.7578 27.2344 19.3047 26.9062L26.7969 22.2578L28.6563 23.2969C29.0938 23.5703 29.3672 24.0078 29.4219 24.5547C29.3672 25.0469 29.0938 25.5391 28.6563 25.8125Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h4 class="font-bold text-xl mb-3">
                All Essential Elements
              </h4>
              <p class="text-foreground opacity-70 mb-8 lg:mb-11">
                Lorem Ipsum is simply dummy text of the printing and industry.
              </p>
              <a
                href="/"
                class="font-medium text-base text-foreground opacity-70 hover:text-primary"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Pricing Play",
    categ: ["sections", "pricing"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-0 items-center">
          <div className="bg-zinc-700 h-14 rounded-l-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 border-2 border-lime-600 h-16 rounded-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-lime-600 h-2"></div>
          </div>
          <div className="bg-zinc-700 h-14 rounded-r-lg flex-1 flex flex-col p-2 justify-between text-zinc-300">
            $<div className="rounded-full w-full bg-zinc-600 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Pricing Play</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section
        id="pricing"
        class="w-full bg-background text-foreground font-body pt-20 lg:pt-[120px] pb-12 lg:pb-[90px] relative z-20 overflow-hidden flex flex-col justify-center items-center"
      >
          <div data-aos="fade-up" class="flex flex-wrap -mx-4 w-full">
            <div class="w-full px-4">
              <div class="text-center mx-auto mb-[60px] lg:mb-20 max-w-[620px]">
                <span class="font-semibold text-lg text-primary mb-2 block">
                  Pricing Table
                </span>
                <h2
                  class="font-bold text-3xl sm:text-4xl md:text-[40px] text-foreground mb-4 font-heading"
                >
                  Our Pricing Plan
                </h2>
                <p
                  class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-foreground opacity-70"
                >
                  There are many variations of passages of Lorem Ipsum available but
                  the majority have suffered alteration in some form.
                </p>
              </div>
            </div>
          </div>
          <div data-aos="fade-up" class="flex flex-wrap items-center justify-center w-full px-6 sm:px-12 md:px-20">
            <div class="w-full md:w-1/2 lg:w-1/3">
              <div
                class="bg-background rounded-xl relative z-10 overflow-hidden border border-foreground/30 shadow-pricing py-10 px-8 sm:p-12 lg:py-10 lg:px-6 xl:p-12 mb-10 text-center wow fadeInUp" data-wow-delay=".15s">
                <span class="text-foreground font-medium text-base uppercase block mb-2">
                  STARTING FROM
                </span>
                <h2 class="font-semibold text-primary mb-9 text-[28px] font-heading">
                  $ 19.99/mo
                </h2>
                <div class="mb-10">
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    1 User
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    All UI components
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Lifetime access
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Free updates
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Use on 1 (one) project
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    3 Months support
                  </p>
                </div>
                <div class="w-full">
                  <a
                    href="/"
                    class="inline-block text-base font-medium text-foreground bg-transparent border border-primary rounded-full text-center py-4 px-9 hover:text-white hover:bg-primary hover:border-primary transition duration-300 ease-in-out"
                  >
                    Purchase Now
                  </a>
                </div>
                <span
                  class="absolute left-0 bottom-0 z-[-1] w-14 h-14 rounded-tr-full block bg-primary"
                >
                </span>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3">
              <div
                class="bg-primary bg-gradient-to-b from-primary via-primary/80 to-secondary/50 rounded-xl relative z-10 overflow-hidden shadow-pricing py-10 px-8 sm:p-12 lg:py-10 lg:px-6 xl:p-12 mb-10 text-center wow fadeInUp"
                data-wow-delay=".3s
                    "
              >
                <span
                  class="inline-block py-2 px-6 border border-white rounded-full text-base font-semibold text-primary bg-white uppercase mb-5"
                >
                  POPULAR
                </span>
                <span class="text-white font-medium text-base uppercase block mb-2">
                  STARTING FROM
                </span>
                <h2 class="font-semibold text-white mb-9 text-[28px] font-heading">$ 19.99/mo</h2>
                <div class="mb-10">
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    5 User
                  </p>
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    All UI components
                  </p>
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    Lifetime access
                  </p>
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    Free updates
                  </p>
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    Use on 1 (one) project
                  </p>
                  <p class="text-base font-medium text-white leading-loose mb-1">
                    4 Months support
                  </p>
                </div>
                <div class="w-full">
                  <a
                    href="/"
                    class="inline-block text-base font-medium text-primary bg-white border border-white rounded-full text-center py-4 px-11 hover:text-foreground hover:bg-primary hover:text-white transition duration-300 ease-in-out"
                  >
                    Purchase Now
                  </a>
                </div>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-1/3">
              <div
                class="bg-background rounded-xl relative z-10 overflow-hidden border border-foreground/30 shadow-pricing py-10 px-8 sm:p-12 lg:py-10 lg:px-6 xl:p-12 mb-10 text-center wow fadeInUp"
                data-wow-delay=".15s
                    "
              >
                <span class="text-foreground font-medium text-base uppercase block mb-2">
                  STARTING FROM
                </span>
                <h2 class="font-semibold text-primary mb-9 text-[28px] font-heading">
                  $ 70.99/mo
                </h2>

                <div class="mb-10">
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    1 User
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    All UI components
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Lifetime access
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Free updates
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    Use on unlimited project
                  </p>
                  <p class="text-base font-medium text-foreground opacity-70 leading-loose mb-1">
                    4 Months support
                  </p>
                </div>
                <div class="w-full">
                  <a
                    href="/"
                    class="inline-block text-base font-medium text-foreground bg-transparent border border-primary rounded-full text-center py-4 px-9 hover:text-foreground hover:bg-primary hover:border-primary transition duration-300 ease-in-out"
                  >
                    Purchase Now
                  </a>
                </div>

                <span
                  class="absolute right-0 top-0 z-[-1] w-14 h-14 rounded-bl-full block bg-secondary"
                >
                </span>
              </div>
            </div>
          </div>
      </section>

      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "FAQs Play",
    categ: ["sections", "faqs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-3">
          <div className="flex flex-col gap-2 w-1/2">
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
          </div>
          <div className="flex flex-col gap-2 w-1/2">
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
            <div className="w-full flex gap-2">
              <div className="w-2 h-2 rounded-full bg-lime-600"></div>
              <div className="w-full h-2 rounded-full bg-zinc-700"></div>
            </div>
          </div>
          
        </div>
        <div className="text-zinc-300 text-xs font-semibold">FAQs Play</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="faqs" class="w-screen bg-background text-foreground font-body pt-20 lg:pt-[120px] pb-12 lg:pb-[90px] relative z-20 overflow-hidden flex flex-col justify-center items-center">
        <div data-aos="fade-up"  class="flex flex-wrap">
          <div class="w-full px-4">
            <div class="text-center mx-auto mb-[60px] lg:mb-20 max-w-[620px]">
              <span class="font-semibold text-lg text-primary mb-2 block">
                FAQ
              </span>
              <h2
                class="font-bold text-3xl sm:text-4xl md:text-[42px] text-foreground mb-4 font-heading"
              >
                Any Questions? Answered
              </h2>
              <p
                class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-foreground opacity-70"
              >
                There are many variations of passages of Lorem Ipsum available but
                the majority have suffered alteration in some form.
              </p>
            </div>
          </div>
        </div>
    
        <div data-aos="fade-up"  class="flex flex-wrap -mx-4 w-full px-6 sm:px-12 md:px-20">
          <div class="w-full lg:w-1/2 px-4">
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".3s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    How to use Makeweb?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".15s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    How to download icons from makeweb?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".2s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    Is makeweb part of makeweb?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/2 px-4">
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".3s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    Can I use this template for commercial project?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".15s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    Do you have plan to releasing Play Pro?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
            <div
              class="single-faq w-full bg-foreground/5 rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
              data-wow-delay=".2s
                  "
            >
              <button class="faq-btn flex items-center w-full text-left">
                <div
                  class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg bg-primary text-primary  mr-5"
                >
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    class="fill-current icon"
                  >
                    <path
                      d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                      fill="#fff"
                      stroke="#fff"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <h4 class="text-base sm:text-lg font-semibold text-foreground">
                    Where and how to host this template?
                  </h4>
                </div>
              </button>
              <div class="faq-content pl-[62px] hidden">
                <p
                  class="text-base text-foreground opacity-70 leading-relaxed py-3"
                >
                  It takes 2-3 weeks to get your first blog post ready. That
                  includes the in-depth research & creation of your monthly content
                  marketing strategy that we do before writing your first blog post,
                  Ipsum available .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>    
      `;
      const script = `
      faqs = document.querySelectorAll(".single-faq");
      faqs.forEach((el) => {
        el.querySelector(".faq-btn").addEventListener("click", () => {
          el.querySelector(".icon").classList.toggle("rotate-180");
          el.querySelector(".faq-content").classList.toggle("hidden");
        });
      });
  `;
      const jsonObj = { ...parseHTMLToJson(htmlCode), script };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Testimonial Play",
    categ: ["sections", "testimonial","people"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col items-center gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-2 w-full justify-between">
            <div className="bg-zinc-700 rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-800 h-2 rounded-lg"></div>
            </div>
            <div className="bg-zinc-700 rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-800 h-2 rounded-lg"></div>
            </div>
            <div className="bg-zinc-700 rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-800 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Testimonials Play
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="testimonials" class="w-full bg-background text-foreground font-body pt-20 md:pt-[120px] flex flex-col justify-center items-center px-6 sm:px-12 md:px-20">
          <div class="container mx-auto">
              <div data-aos="fade-up" class="flex flex-wrap">
                  <div class="w-full mx-4">
                      <div class="text-center mx-auto mb-[60px] lg:mb-20 max-w-[620px]">
                          <span class="font-semibold text-lg text-primary mb-2 block">
                              Testimonials
                          </span>
                          <h2 class="font-bold text-3xl sm:text-4xl md:text-[42px] text-foreground mb-4 font-heading">
                              What Our Users Say
                          </h2>
                          <p class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-foreground opacity-70">
                              Our AI-powered solutions have transformed the way our users build and manage websites. Here's what they have to say.
                          </p>
                      </div>
                  </div>
              </div>
              <div data-aos="fade-up" class="flex flex-wrap justify-center">
                  <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                      <div class="bg-foreground/5 p-8 mb-12 shadow-md rounded-lg" data-wow-delay=".1s">
                          <div class="flex items-center gap-1 mb-3 text-yellow-600">
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                          </div>
                          <div class="mb-6">
                              <p class="text-base tracking-wide text-foreground opacity-70">
                                  “The AI website builder is incredibly intuitive and efficient. It has streamlined our workflow and enhanced our productivity.”
                              </p>
                          </div>
                          <div class="flex items-center">
                              <div class="w-[50px] h-[50px] rounded-full overflow-hidden mr-5">
                                  <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818859357" alt="author"/>
                              </div>
                              <div>
                                  <h4 class="text-sm font-semibold">Sabo Masties</h4>
                                  <p class="text-[#969696] text-xs">Founder @ Rolex</p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                      <div class="bg-foreground/5 p-8 mb-12 shadow-md rounded-lg" data-wow-delay=".15s">
                          <div class="flex items-center gap-1 mb-3 text-yellow-600">
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                          </div>
                          <div class="mb-6">
                              <p class="text-base tracking-wide text-foreground opacity-70">
                                  “This tool is a game-changer. Our website development process is faster and more efficient thanks to the AI integration.”
                              </p>
                          </div>
                          <div class="flex items-center">
                              <div class="w-[50px] h-[50px] rounded-full overflow-hidden mr-5">
                                  <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818822435" alt="author"/>
                              </div>
                              <div>
                                  <h4 class="text-sm font-semibold">Margin Gesmu</h4>
                                  <p class="text-[#969696] text-xs">Founder @ UI Hunter</p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                      <div class="bg-foreground/5 p-8 mb-12 shadow-md rounded-lg" data-wow-delay=".2s">
                          <div class="flex items-center gap-1 mb-3 text-yellow-600">
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                              ${toStr(<PiStarFill className="w-4 h-auto"/>)}
                          </div>
                          <div class="mb-6">
                              <p class="text-base tracking-wide text-foreground opacity-70">
                                  “Building websites has never been this easy. The AI tools provided have significantly improved our design and development process.”
                              </p>
                          </div>
                          <div class="flex items-center">
                              <div class="w-[50px] h-[50px] rounded-full overflow-hidden mr-5">
                                  <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-nahidsami102@gmail.com/pageId-660835ca6bf67ea5682f1c00/image-1711818841412" alt="author"/>
                              </div>
                              <div>
                                  <h4 class="text-sm font-semibold">William Smith</h4>
                                  <p class="text-[#969696] text-xs">Founder @ Trorex</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>`;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Trusted By",
    categ: ["sections", "misc"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col items-center gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-3 w-full justify-between">
            <div className="bg-lime-600 rounded-md flex-1 flex flex-col items-center gap-2 h-2"></div>
            <div className="bg-lime-600 rounded-md flex-1 flex flex-col items-center gap-2 h-2"></div>
            <div className="bg-lime-600 rounded-md flex-1 flex flex-col items-center gap-2 h-2"></div>
            <div className="bg-lime-600 rounded-md flex-1 flex flex-col items-center gap-2 h-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Trusted By
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="clients" class="w-full px-6 sm:px-12 lg:px-20 py-10 lg:py-14 mx-auto bg-background text-foreground font-body">
        <div class="max-w-[85rem] w-full flex flex-col gap-6">
          <div class="w-2/3 sm:w-1/2 lg:w-1/3 mx-auto flex justify-center">
            <h2 class="text-foreground/70 font-semibold">Trusted by Top Compaines</h2>
          </div>
          <div class="w-full flex justify-center items-center flex-wrap gap-x-6 sm:gap-x-12 lg:gap-x-24">
            <img class="py-3 h-14 w-auto mx-auto sm:mx-0" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716727531283" alt="Client 1 Logo"/>
            <img class="py-3 h-14 w-auto mx-auto sm:mx-0" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716727541861" alt="Client 2 Logo"/>
            <img class="py-3 h-14 w-auto mx-auto sm:mx-0" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716727551404" alt="Client 3 Logo"/>
            <img class="py-3 h-14 w-auto mx-auto sm:mx-0" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716727564730" alt="Client 4 Logo"/>
            <img class="py-3 h-14 w-auto mx-auto sm:mx-0" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716727713859" alt="Client 5 Logo"/>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Team Section Play",
    categ: ["sections", "team","people"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col items-center gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-2 w-full justify-between">
            <div className="rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-center gap-2 p-2">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Team Section Play
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="team" class="w-full bg-background text-foreground font-body pt-20 lg:pt-[120px] pb-10 lg:pb-20 flex flex-col justify-center items-center">
        <div data-aos="fade-up" class="flex flex-wrap w-full">
          <div class="w-full px-4">
            <div class="text-center mx-auto mb-[60px] max-w-[620px]">
              <span class="font-semibold text-lg text-primary mb-2 block">
                Our Team
              </span>
              <h2
                class="font-bold text-3xl sm:text-4xl md:text-[42px] text-dark mb-4 font-heading"
              >
                Meet Our Team
              </h2>
              <p
                class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-foreground opacity-70"
              >
                There are many variations of passages of Lorem Ipsum available but
                the majority have suffered alteration in some form.
              </p>
            </div>
          </div>
        </div>
    
        <div data-aos="fade-up" class="w-full flex flex-wrap justify-center md:px-16">
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4">
            <div class="mb-10 wow fadeInUp" data-wow-delay=".1s">
              <div
                class="relative w-[130px] h-[130px] rounded-full z-10 mx-auto mb-6"
              >
                <img
                  src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662047219bd2d8b24d5b273a/image-1713629067825"
                  alt="image"
                  class="w-[130px] h-[130px] rounded-full"
                />
                <span class="absolute top-[-15px] left-[-15px] z-[-1]">
                  <svg
                    width="71"
                    height="82"
                    viewBox="0 0 71 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.29337"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 1.29337 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 12.6747 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 24.0575 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 35.4379 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 46.8197 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 68.807 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 57.9443 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 1.29337 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 12.6747 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 24.0575 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 35.4379 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 46.8197 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 68.807 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 57.9433 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 1.29337 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 1.29337 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 12.6747 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 12.6747 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 24.0575 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 24.0575 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 35.4379 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 35.4379 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 46.8197 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 46.8197 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 68.807 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 68.807 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 57.9433 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 57.9443 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 1.29337 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 1.29337 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 12.6747 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 12.6747 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 24.0575 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 24.0575 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 35.4379 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 35.4379 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 46.8197 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 46.8197 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 68.807 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 68.807 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 57.9433 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 57.9443 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 1.29337 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 1.29337 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 12.6747 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 12.6747 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 24.0575 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 24.0575 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 35.4379 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 35.4379 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 46.8197 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 46.8197 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 68.807 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 68.807 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 57.9443 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 57.9443 1.29354)"
                      class="fill-primary"
                    />
                  </svg>
                </span>
                <span class="absolute right-0 bottom-0">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5 21.5L0.505701 21.5C0.767606 10.023 10.023 0.767604 21.5 0.505697L21.5 21.5Z"
                      class="stroke-primary"
                    />
                  </svg>
                </span>
              </div>
              <div class="text-center">
                <h4 class="font-medium text-lg text-dark mb-2">Adveen Desuza</h4>
                <p class="font-medium text-sm text-foreground opacity-70 mb-5">
                  UI Designer
                </p>
                <div class="flex items-center justify-center">
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="10"
                      height="18"
                      viewBox="0 0 10 18"
                      class="fill-current"
                    >
                      <path
                        d="M9.29878 7.2H7.74898H7.19548V6.61935V4.81936V4.23871H7.74898H8.91133C9.21575 4.23871 9.46483 4.00645 9.46483 3.65806V0.580645C9.46483 0.26129 9.24343 0 8.91133 0H6.89106C4.70474 0 3.18262 1.62581 3.18262 4.03548V6.56129V7.14194H2.62912H0.747223C0.359774 7.14194 0 7.46129 0 7.92581V10.0161C0 10.4226 0.304424 10.8 0.747223 10.8H2.57377H3.12727V11.3806V17.2161C3.12727 17.6226 3.43169 18 3.87449 18H6.47593C6.64198 18 6.78036 17.9129 6.89106 17.7968C7.00176 17.6806 7.08478 17.4774 7.08478 17.3032V11.4097V10.829H7.66596H8.91133C9.2711 10.829 9.54785 10.5968 9.6032 10.2484V10.2194V10.1903L9.99065 8.1871C10.0183 7.98387 9.99065 7.75161 9.8246 7.51935C9.76925 7.37419 9.52018 7.22903 9.29878 7.2Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      class="fill-current"
                    >
                      <path
                        d="M15.9968 2.41096L17.1 1.09589C17.4194 0.739726 17.5065 0.465753 17.5355 0.328767C16.6645 0.821918 15.8516 0.986301 15.329 0.986301H15.1258L15.0097 0.876712C14.3129 0.30137 13.4419 0 12.5129 0C10.4806 0 8.88387 1.58904 8.88387 3.42466C8.88387 3.53425 8.88387 3.69863 8.9129 3.80822L9 4.35616L8.39032 4.32877C4.67419 4.21918 1.62581 1.20548 1.13226 0.684932C0.319355 2.05479 0.783871 3.36986 1.27742 4.19178L2.26452 5.72603L0.696774 4.90411C0.725806 6.05479 1.19032 6.9589 2.09032 7.61644L2.87419 8.16438L2.09032 8.46575C2.58387 9.86301 3.6871 10.4384 4.5 10.6575L5.57419 10.9315L4.55806 11.589C2.93226 12.6849 0.9 12.6027 0 12.5205C1.82903 13.726 4.00645 14 5.51613 14C6.64839 14 7.49032 13.8904 7.69355 13.8082C15.8226 12 16.2 5.15068 16.2 3.78082V3.58904L16.3742 3.47945C17.3613 2.60274 17.7677 2.13699 18 1.86301C17.9129 1.89041 17.7968 1.94521 17.6806 1.9726L15.9968 2.41096Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      class="fill-current"
                    >
                      <path
                        d="M8.90245 12.1939C10.7363 12.1939 12.2229 10.7073 12.2229 8.87352C12.2229 7.0397 10.7363 5.5531 8.90245 5.5531C7.06863 5.5531 5.58203 7.0397 5.58203 8.87352C5.58203 10.7073 7.06863 12.1939 8.90245 12.1939Z"
                      />
                      <path
                        d="M12.5088 0H5.23824C2.34719 0 0 2.34719 0 5.23824V12.4516C0 15.3999 2.34719 17.7471 5.23824 17.7471H12.4516C15.3999 17.7471 17.7471 15.3999 17.7471 12.5088V5.23824C17.7471 2.34719 15.3999 0 12.5088 0ZM8.90215 13.2244C6.46909 13.2244 4.55126 11.2493 4.55126 8.87353C4.55126 6.49771 6.49771 4.52264 8.90215 4.52264C11.278 4.52264 13.2244 6.49771 13.2244 8.87353C13.2244 11.2493 11.3066 13.2244 8.90215 13.2244ZM14.9133 4.92338C14.627 5.23824 14.1976 5.40999 13.711 5.40999C13.2817 5.40999 12.8523 5.23824 12.5088 4.92338C12.1939 4.60851 12.0222 4.20777 12.0222 3.72116C12.0222 3.23454 12.1939 2.86243 12.5088 2.51894C12.8237 2.17545 13.2244 2.0037 13.711 2.0037C14.1404 2.0037 14.5984 2.17545 14.9133 2.49031C15.1995 2.86243 15.3999 3.29179 15.3999 3.74978C15.3712 4.20777 15.1995 4.60851 14.9133 4.92338Z"
                      />
                      <path
                        d="M13.7397 3.03418C13.3676 3.03418 13.0527 3.34905 13.0527 3.72116C13.0527 4.09328 13.3676 4.40815 13.7397 4.40815C14.1118 4.40815 14.4267 4.09328 14.4267 3.72116C14.4267 3.34905 14.1405 3.03418 13.7397 3.03418Z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4">
            <div class="mb-10 wow fadeInUp" data-wow-delay=".15s">
              <div
                class="relative w-[130px] h-[130px] rounded-full z-10 mx-auto mb-6"
              >
                <img
                  src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662047219bd2d8b24d5b273a/image-1713629131215"
                  alt="image"
                  class="w-[130px] h-[130px] rounded-full"
                />
                <span class="absolute top-[-15px] left-[-15px] z-[-1]">
                  <svg
                    width="71"
                    height="82"
                    viewBox="0 0 71 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.29337"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 1.29337 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 12.6747 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 24.0575 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 35.4379 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 46.8197 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 68.807 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 57.9443 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 1.29337 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 12.6747 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 24.0575 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 35.4379 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 46.8197 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 68.807 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 57.9433 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 1.29337 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 1.29337 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 12.6747 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 12.6747 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 24.0575 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 24.0575 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 35.4379 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 35.4379 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 46.8197 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 46.8197 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 68.807 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 68.807 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 57.9433 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 57.9443 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 1.29337 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 1.29337 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 12.6747 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 12.6747 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 24.0575 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 24.0575 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 35.4379 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 35.4379 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 46.8197 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 46.8197 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 68.807 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 68.807 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 57.9433 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 57.9443 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 1.29337 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 1.29337 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 12.6747 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 12.6747 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 24.0575 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 24.0575 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 35.4379 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 35.4379 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 46.8197 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 46.8197 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 68.807 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 68.807 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 57.9443 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 57.9443 1.29354)"
                      class="fill-primary"
                    />
                  </svg>
                </span>
                <span class="absolute right-0 bottom-0">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5 21.5L0.505701 21.5C0.767606 10.023 10.023 0.767604 21.5 0.505697L21.5 21.5Z"
                      class="stroke-primary"
                    />
                  </svg>
                </span>
              </div>
              <div class="text-center">
                <h4 class="font-medium text-lg text-dark mb-2">Jezmin uniya</h4>
                <p class="font-medium text-sm text-foreground opacity-70 mb-5">
                  Product Designer
                </p>
                <div class="flex items-center justify-center">
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="10"
                      height="18"
                      viewBox="0 0 10 18"
                      class="fill-current"
                    >
                      <path
                        d="M9.29878 7.2H7.74898H7.19548V6.61935V4.81936V4.23871H7.74898H8.91133C9.21575 4.23871 9.46483 4.00645 9.46483 3.65806V0.580645C9.46483 0.26129 9.24343 0 8.91133 0H6.89106C4.70474 0 3.18262 1.62581 3.18262 4.03548V6.56129V7.14194H2.62912H0.747223C0.359774 7.14194 0 7.46129 0 7.92581V10.0161C0 10.4226 0.304424 10.8 0.747223 10.8H2.57377H3.12727V11.3806V17.2161C3.12727 17.6226 3.43169 18 3.87449 18H6.47593C6.64198 18 6.78036 17.9129 6.89106 17.7968C7.00176 17.6806 7.08478 17.4774 7.08478 17.3032V11.4097V10.829H7.66596H8.91133C9.2711 10.829 9.54785 10.5968 9.6032 10.2484V10.2194V10.1903L9.99065 8.1871C10.0183 7.98387 9.99065 7.75161 9.8246 7.51935C9.76925 7.37419 9.52018 7.22903 9.29878 7.2Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      class="fill-current"
                    >
                      <path
                        d="M15.9968 2.41096L17.1 1.09589C17.4194 0.739726 17.5065 0.465753 17.5355 0.328767C16.6645 0.821918 15.8516 0.986301 15.329 0.986301H15.1258L15.0097 0.876712C14.3129 0.30137 13.4419 0 12.5129 0C10.4806 0 8.88387 1.58904 8.88387 3.42466C8.88387 3.53425 8.88387 3.69863 8.9129 3.80822L9 4.35616L8.39032 4.32877C4.67419 4.21918 1.62581 1.20548 1.13226 0.684932C0.319355 2.05479 0.783871 3.36986 1.27742 4.19178L2.26452 5.72603L0.696774 4.90411C0.725806 6.05479 1.19032 6.9589 2.09032 7.61644L2.87419 8.16438L2.09032 8.46575C2.58387 9.86301 3.6871 10.4384 4.5 10.6575L5.57419 10.9315L4.55806 11.589C2.93226 12.6849 0.9 12.6027 0 12.5205C1.82903 13.726 4.00645 14 5.51613 14C6.64839 14 7.49032 13.8904 7.69355 13.8082C15.8226 12 16.2 5.15068 16.2 3.78082V3.58904L16.3742 3.47945C17.3613 2.60274 17.7677 2.13699 18 1.86301C17.9129 1.89041 17.7968 1.94521 17.6806 1.9726L15.9968 2.41096Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      class="fill-current"
                    >
                      <path
                        d="M8.90245 12.1939C10.7363 12.1939 12.2229 10.7073 12.2229 8.87352C12.2229 7.0397 10.7363 5.5531 8.90245 5.5531C7.06863 5.5531 5.58203 7.0397 5.58203 8.87352C5.58203 10.7073 7.06863 12.1939 8.90245 12.1939Z"
                      />
                      <path
                        d="M12.5088 0H5.23824C2.34719 0 0 2.34719 0 5.23824V12.4516C0 15.3999 2.34719 17.7471 5.23824 17.7471H12.4516C15.3999 17.7471 17.7471 15.3999 17.7471 12.5088V5.23824C17.7471 2.34719 15.3999 0 12.5088 0ZM8.90215 13.2244C6.46909 13.2244 4.55126 11.2493 4.55126 8.87353C4.55126 6.49771 6.49771 4.52264 8.90215 4.52264C11.278 4.52264 13.2244 6.49771 13.2244 8.87353C13.2244 11.2493 11.3066 13.2244 8.90215 13.2244ZM14.9133 4.92338C14.627 5.23824 14.1976 5.40999 13.711 5.40999C13.2817 5.40999 12.8523 5.23824 12.5088 4.92338C12.1939 4.60851 12.0222 4.20777 12.0222 3.72116C12.0222 3.23454 12.1939 2.86243 12.5088 2.51894C12.8237 2.17545 13.2244 2.0037 13.711 2.0037C14.1404 2.0037 14.5984 2.17545 14.9133 2.49031C15.1995 2.86243 15.3999 3.29179 15.3999 3.74978C15.3712 4.20777 15.1995 4.60851 14.9133 4.92338Z"
                      />
                      <path
                        d="M13.7397 3.03418C13.3676 3.03418 13.0527 3.34905 13.0527 3.72116C13.0527 4.09328 13.3676 4.40815 13.7397 4.40815C14.1118 4.40815 14.4267 4.09328 14.4267 3.72116C14.4267 3.34905 14.1405 3.03418 13.7397 3.03418Z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4">
            <div class="mb-10 wow fadeInUp" data-wow-delay=".2s">
              <div
                class="relative w-[130px] h-[130px] rounded-full z-10 mx-auto mb-6"
              >
                <img
                  src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662047219bd2d8b24d5b273a/image-1713629148203"
                  alt="image"
                  class="w-[130px] h-[130px] rounded-full"
                />
                <span class="absolute top-[-15px] left-[-15px] z-[-1]">
                  <svg
                    width="71"
                    height="82"
                    viewBox="0 0 71 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.29337"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 1.29337 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 12.6747 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 24.0575 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 35.4379 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 46.8197 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 68.807 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 57.9443 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 1.29337 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 12.6747 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 24.0575 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 35.4379 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 46.8197 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 68.807 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 57.9433 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 1.29337 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 1.29337 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 12.6747 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 12.6747 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 24.0575 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 24.0575 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 35.4379 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 35.4379 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 46.8197 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 46.8197 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 68.807 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 68.807 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 57.9433 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 57.9443 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 1.29337 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 1.29337 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 12.6747 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 12.6747 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 24.0575 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 24.0575 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 35.4379 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 35.4379 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 46.8197 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 46.8197 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 68.807 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 68.807 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 57.9433 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 57.9443 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 1.29337 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 1.29337 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 12.6747 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 12.6747 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 24.0575 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 24.0575 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 35.4379 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 35.4379 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 46.8197 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 46.8197 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 68.807 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 68.807 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 57.9443 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 57.9443 1.29354)"
                      class="fill-primary"
                    />
                  </svg>
                </span>
                <span class="absolute right-0 bottom-0">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5 21.5L0.505701 21.5C0.767606 10.023 10.023 0.767604 21.5 0.505697L21.5 21.5Z"
                      class="stroke-primary"
                    />
                  </svg>
                </span>
              </div>
              <div class="text-center">
                <h4 class="font-medium text-lg text-dark mb-2">Andrieo Gloree</h4>
                <p class="font-medium text-sm text-foreground opacity-70 mb-5">
                  App Developer
                </p>
                <div class="flex items-center justify-center">
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="10"
                      height="18"
                      viewBox="0 0 10 18"
                      class="fill-current"
                    >
                      <path
                        d="M9.29878 7.2H7.74898H7.19548V6.61935V4.81936V4.23871H7.74898H8.91133C9.21575 4.23871 9.46483 4.00645 9.46483 3.65806V0.580645C9.46483 0.26129 9.24343 0 8.91133 0H6.89106C4.70474 0 3.18262 1.62581 3.18262 4.03548V6.56129V7.14194H2.62912H0.747223C0.359774 7.14194 0 7.46129 0 7.92581V10.0161C0 10.4226 0.304424 10.8 0.747223 10.8H2.57377H3.12727V11.3806V17.2161C3.12727 17.6226 3.43169 18 3.87449 18H6.47593C6.64198 18 6.78036 17.9129 6.89106 17.7968C7.00176 17.6806 7.08478 17.4774 7.08478 17.3032V11.4097V10.829H7.66596H8.91133C9.2711 10.829 9.54785 10.5968 9.6032 10.2484V10.2194V10.1903L9.99065 8.1871C10.0183 7.98387 9.99065 7.75161 9.8246 7.51935C9.76925 7.37419 9.52018 7.22903 9.29878 7.2Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      class="fill-current"
                    >
                      <path
                        d="M15.9968 2.41096L17.1 1.09589C17.4194 0.739726 17.5065 0.465753 17.5355 0.328767C16.6645 0.821918 15.8516 0.986301 15.329 0.986301H15.1258L15.0097 0.876712C14.3129 0.30137 13.4419 0 12.5129 0C10.4806 0 8.88387 1.58904 8.88387 3.42466C8.88387 3.53425 8.88387 3.69863 8.9129 3.80822L9 4.35616L8.39032 4.32877C4.67419 4.21918 1.62581 1.20548 1.13226 0.684932C0.319355 2.05479 0.783871 3.36986 1.27742 4.19178L2.26452 5.72603L0.696774 4.90411C0.725806 6.05479 1.19032 6.9589 2.09032 7.61644L2.87419 8.16438L2.09032 8.46575C2.58387 9.86301 3.6871 10.4384 4.5 10.6575L5.57419 10.9315L4.55806 11.589C2.93226 12.6849 0.9 12.6027 0 12.5205C1.82903 13.726 4.00645 14 5.51613 14C6.64839 14 7.49032 13.8904 7.69355 13.8082C15.8226 12 16.2 5.15068 16.2 3.78082V3.58904L16.3742 3.47945C17.3613 2.60274 17.7677 2.13699 18 1.86301C17.9129 1.89041 17.7968 1.94521 17.6806 1.9726L15.9968 2.41096Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      class="fill-current"
                    >
                      <path
                        d="M8.90245 12.1939C10.7363 12.1939 12.2229 10.7073 12.2229 8.87352C12.2229 7.0397 10.7363 5.5531 8.90245 5.5531C7.06863 5.5531 5.58203 7.0397 5.58203 8.87352C5.58203 10.7073 7.06863 12.1939 8.90245 12.1939Z"
                      />
                      <path
                        d="M12.5088 0H5.23824C2.34719 0 0 2.34719 0 5.23824V12.4516C0 15.3999 2.34719 17.7471 5.23824 17.7471H12.4516C15.3999 17.7471 17.7471 15.3999 17.7471 12.5088V5.23824C17.7471 2.34719 15.3999 0 12.5088 0ZM8.90215 13.2244C6.46909 13.2244 4.55126 11.2493 4.55126 8.87353C4.55126 6.49771 6.49771 4.52264 8.90215 4.52264C11.278 4.52264 13.2244 6.49771 13.2244 8.87353C13.2244 11.2493 11.3066 13.2244 8.90215 13.2244ZM14.9133 4.92338C14.627 5.23824 14.1976 5.40999 13.711 5.40999C13.2817 5.40999 12.8523 5.23824 12.5088 4.92338C12.1939 4.60851 12.0222 4.20777 12.0222 3.72116C12.0222 3.23454 12.1939 2.86243 12.5088 2.51894C12.8237 2.17545 13.2244 2.0037 13.711 2.0037C14.1404 2.0037 14.5984 2.17545 14.9133 2.49031C15.1995 2.86243 15.3999 3.29179 15.3999 3.74978C15.3712 4.20777 15.1995 4.60851 14.9133 4.92338Z"
                      />
                      <path
                        d="M13.7397 3.03418C13.3676 3.03418 13.0527 3.34905 13.0527 3.72116C13.0527 4.09328 13.3676 4.40815 13.7397 4.40815C14.1118 4.40815 14.4267 4.09328 14.4267 3.72116C14.4267 3.34905 14.1405 3.03418 13.7397 3.03418Z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full sm:w-1/2 lg:w-1/4 px-4">
            <div class="mb-10 wow fadeInUp" data-wow-delay=".25s">
              <div
                class="relative w-[130px] h-[130px] flex items-center justify-center rounded-full z-10 mx-auto mb-6"
              >
                <img
                  src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/pageId-662047219bd2d8b24d5b273a/image-1713629067825"
                  alt="image"
                  class="w-[130px] h-[130px] rounded-full"
                />
                <span class="absolute top-[-15px] left-[-15px] z-[-1]">
                  <svg
                    width="71"
                    height="82"
                    viewBox="0 0 71 82"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="1.29337"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 1.29337 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 12.6747 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 24.0575 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 35.4379 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 46.8197 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 68.807 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="80.7066"
                      r="1.29337"
                      transform="rotate(-90 57.9443 80.7066)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 1.29337 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 12.6747 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 24.0575 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="69.3249"
                      r="1.29337"
                      transform="rotate(-90 35.4379 69.3249)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 46.8197 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 68.807 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="69.325"
                      r="1.29337"
                      transform="rotate(-90 57.9433 69.325)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 1.29337 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 1.29337 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 12.6747 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 12.6747 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 24.0575 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 24.0575 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="57.9433"
                      r="1.29337"
                      transform="rotate(-90 35.4379 57.9433)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="24.0568"
                      r="1.29337"
                      transform="rotate(-90 35.4379 24.0568)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 46.8197 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 46.8197 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 68.807 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 68.807 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="57.9431"
                      r="1.29337"
                      transform="rotate(-90 57.9433 57.9431)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="24.0567"
                      r="1.29337"
                      transform="rotate(-90 57.9443 24.0567)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 1.29337 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 1.29337 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 12.6747 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 12.6747 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 24.0575 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 24.0575 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 35.4379 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 35.4379 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 46.8197 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 46.8197 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 68.807 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 68.807 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9433"
                      cy="46.5615"
                      r="1.29337"
                      transform="rotate(-90 57.9433 46.5615)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="12.6751"
                      r="1.29337"
                      transform="rotate(-90 57.9443 12.6751)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 1.29337 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="1.29337"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 1.29337 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 12.6747 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="12.6747"
                      cy="1.2933"
                      r="1.29337"
                      transform="rotate(-90 12.6747 1.2933)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 24.0575 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="24.0575"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 24.0575 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="35.1798"
                      r="1.29337"
                      transform="rotate(-90 35.4379 35.1798)"
                      class="fill-primary"
                    />
                    <circle
                      cx="35.4379"
                      cy="1.29336"
                      r="1.29337"
                      transform="rotate(-90 35.4379 1.29336)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 46.8197 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="46.8197"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 46.8197 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 68.807 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="68.807"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 68.807 1.29354)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="35.18"
                      r="1.29337"
                      transform="rotate(-90 57.9443 35.18)"
                      class="fill-primary"
                    />
                    <circle
                      cx="57.9443"
                      cy="1.29354"
                      r="1.29337"
                      transform="rotate(-90 57.9443 1.29354)"
                      class="fill-primary"
                    />
                  </svg>
                </span>
                <span class="absolute right-0 bottom-0">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5 21.5L0.505701 21.5C0.767606 10.023 10.023 0.767604 21.5 0.505697L21.5 21.5Z"
                      class="stroke-primary"
                    />
                  </svg>
                </span>
              </div>
              <div class="text-center">
                <h4 class="font-medium text-lg text-dark mb-2">Jackie Sanders</h4>
                <p class="font-medium text-sm text-foreground opacity-70 mb-5">
                  Content Writer
                </p>
                <div class="flex items-center justify-center">
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="10"
                      height="18"
                      viewBox="0 0 10 18"
                      class="fill-current"
                    >
                      <path
                        d="M9.29878 7.2H7.74898H7.19548V6.61935V4.81936V4.23871H7.74898H8.91133C9.21575 4.23871 9.46483 4.00645 9.46483 3.65806V0.580645C9.46483 0.26129 9.24343 0 8.91133 0H6.89106C4.70474 0 3.18262 1.62581 3.18262 4.03548V6.56129V7.14194H2.62912H0.747223C0.359774 7.14194 0 7.46129 0 7.92581V10.0161C0 10.4226 0.304424 10.8 0.747223 10.8H2.57377H3.12727V11.3806V17.2161C3.12727 17.6226 3.43169 18 3.87449 18H6.47593C6.64198 18 6.78036 17.9129 6.89106 17.7968C7.00176 17.6806 7.08478 17.4774 7.08478 17.3032V11.4097V10.829H7.66596H8.91133C9.2711 10.829 9.54785 10.5968 9.6032 10.2484V10.2194V10.1903L9.99065 8.1871C10.0183 7.98387 9.99065 7.75161 9.8246 7.51935C9.76925 7.37419 9.52018 7.22903 9.29878 7.2Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      class="fill-current"
                    >
                      <path
                        d="M15.9968 2.41096L17.1 1.09589C17.4194 0.739726 17.5065 0.465753 17.5355 0.328767C16.6645 0.821918 15.8516 0.986301 15.329 0.986301H15.1258L15.0097 0.876712C14.3129 0.30137 13.4419 0 12.5129 0C10.4806 0 8.88387 1.58904 8.88387 3.42466C8.88387 3.53425 8.88387 3.69863 8.9129 3.80822L9 4.35616L8.39032 4.32877C4.67419 4.21918 1.62581 1.20548 1.13226 0.684932C0.319355 2.05479 0.783871 3.36986 1.27742 4.19178L2.26452 5.72603L0.696774 4.90411C0.725806 6.05479 1.19032 6.9589 2.09032 7.61644L2.87419 8.16438L2.09032 8.46575C2.58387 9.86301 3.6871 10.4384 4.5 10.6575L5.57419 10.9315L4.55806 11.589C2.93226 12.6849 0.9 12.6027 0 12.5205C1.82903 13.726 4.00645 14 5.51613 14C6.64839 14 7.49032 13.8904 7.69355 13.8082C15.8226 12 16.2 5.15068 16.2 3.78082V3.58904L16.3742 3.47945C17.3613 2.60274 17.7677 2.13699 18 1.86301C17.9129 1.89041 17.7968 1.94521 17.6806 1.9726L15.9968 2.41096Z"
                      />
                    </svg>
                  </a>
                  <a
                    href="/"
                    class="text-[#cdced6] hover:text-primary w-8 h-8 mx-2 flex items-center justify-center"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      class="fill-current"
                    >
                      <path
                        d="M8.90245 12.1939C10.7363 12.1939 12.2229 10.7073 12.2229 8.87352C12.2229 7.0397 10.7363 5.5531 8.90245 5.5531C7.06863 5.5531 5.58203 7.0397 5.58203 8.87352C5.58203 10.7073 7.06863 12.1939 8.90245 12.1939Z"
                      />
                      <path
                        d="M12.5088 0H5.23824C2.34719 0 0 2.34719 0 5.23824V12.4516C0 15.3999 2.34719 17.7471 5.23824 17.7471H12.4516C15.3999 17.7471 17.7471 15.3999 17.7471 12.5088V5.23824C17.7471 2.34719 15.3999 0 12.5088 0ZM8.90215 13.2244C6.46909 13.2244 4.55126 11.2493 4.55126 8.87353C4.55126 6.49771 6.49771 4.52264 8.90215 4.52264C11.278 4.52264 13.2244 6.49771 13.2244 8.87353C13.2244 11.2493 11.3066 13.2244 8.90215 13.2244ZM14.9133 4.92338C14.627 5.23824 14.1976 5.40999 13.711 5.40999C13.2817 5.40999 12.8523 5.23824 12.5088 4.92338C12.1939 4.60851 12.0222 4.20777 12.0222 3.72116C12.0222 3.23454 12.1939 2.86243 12.5088 2.51894C12.8237 2.17545 13.2244 2.0037 13.711 2.0037C14.1404 2.0037 14.5984 2.17545 14.9133 2.49031C15.1995 2.86243 15.3999 3.29179 15.3999 3.74978C15.3712 4.20777 15.1995 4.60851 14.9133 4.92338Z"
                      />
                      <path
                        d="M13.7397 3.03418C13.3676 3.03418 13.0527 3.34905 13.0527 3.72116C13.0527 4.09328 13.3676 4.40815 13.7397 4.40815C14.1118 4.40815 14.4267 4.09328 14.4267 3.72116C14.4267 3.34905 14.1405 3.03418 13.7397 3.03418Z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "CTA with Primary",
    categ: ["sections", "cta-section"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center gap-2">
          <div className="flex-grow p-1 flex flex-col gap-2 items-start justify-center w-1/2">
            <div className="bg-zinc-700 rounded-xl w-full h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-2"></div>
            <div className="w-full flex gap-1">
              <div className="bg-lime-600 rounded-xl w-1/3 h-2"></div>
            </div>
          </div>
          <div className="bg-zinc-700 w-1/2 h-10 rounded-lg"></div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">CTA Primary</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section class="w-screen py-6 px-6 sm:px-12 md:px-20 bg-background text-foreground font-body">
        <div data-aos="fade-up" class="gap-5 items-center flex flex-col lg:flex-row w-full">
          <div class="flex-1 max-w-lg py-5 sm:text-center lg:max-w-max lg:text-left flex flex-col md:items-center lg:items-start gap-4">
            <h2 class="text-3xl text-foreground font-heading font-semibold md:text-4xl">
              Create your <span class="text-primary">websites</span> with AI driven precision
            </h2>
            <p class="text-foreground/50 leading-relaxed">
              Experience seamless design and top-tier performance. Let our AI handle the heavy lifting while you focus on your vision.
            </p>
            <a class="px-5 py-2 text-primary font-medium bg-primary/10 rounded-full flex gap-2 items-center w-fit" href="/">
              Get Started
              ${toStr(
                <FaArrowRightLong className="h-4 w-4"/>
              )}
            </a>
          </div>
          <div class="flex-1 sm:w-9/12">
            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-664fbc12bc230fd73eb9b1a7/image-1716546410137" alt="Blue Vector" class="w-full h-80 object-cover" />
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "CTA Centered",
    categ: ["sections", "cta-section"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-2 bg-zinc-800 rounded-lg flex justify-between items-center">
          <div className="flex-grow p-1 flex flex-col gap-2 items-center justify-center">
            <div className="bg-zinc-700 rounded-xl w-1/2 h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-1"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-1"></div>
            <div className="flex gap-1 w-full justify-center">
              <div className="bg-lime-600 rounded-xl w-4 h-2"></div>
              <div className="bg-zinc-700 rounded-xl w-4 h-2"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">CTA centered</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section class="w-screen py-14 bg-background text-foreground font-body">
        <div data-aos="fade-up" class="w-full max-w-3xl mx-auto px-6 md:px-10  space-y-4">
          <h2 class="max-w-3xl md:text-center text-3xl font-semibold text-foreground sm:text-4xl font-heading">
            Revolutionize Your Web Creation
          </h2>
          <p class="max-w-2xl md:text-center text-foreground/50">
            Harness the capabilities of AI to design breathtaking websites with ease. Join us and transform the web development landscape.
          </p>
          <div class="flex items-center gap-4  md:justify-center font-medium">
            <a href="" class="px-6 py-2 text-white bg-primary/80 rounded-xl shadow-md duration-200 hover:bg-primary/100 hover:shadow-none">
              Get Started
            </a>
            <a href="" class="px-6 py-2 text-foreground border rounded-xl duration-200 hover:bg-foreground/10 active:bg-foreground/10">
              Explore
            </a>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "CTA with Image",
    categ: ["sections", "cta-section"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-3 bg-zinc-800 rounded-lg flex justify-between items-center gap-2">
          <div className="bg-zinc-700 w-1/2 h-10 rounded-lg"></div>
          <div className="flex-grow p-1 flex flex-col gap-2 items-start justify-center w-1/2">
            <div className="bg-zinc-700 rounded-xl w-full h-2"></div>
            <div className="bg-zinc-700 opacity-80 rounded-xl w-2/3 h-2"></div>
            <div className="w-full flex gap-1">
              <div className="bg-lime-600 rounded-xl w-1/3 h-1"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          CTA Right
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section class="w-screen py-14 bg-background text-foreground font-body px-6 sm:px-12 md:px-20">
        <div data-aos="fade-left" class="container mx-auto">
          <div class="flex flex-col lg:flex-row items-center gap-6 gap-x-12">
            <div class="flex-1">
              <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-664fbc12bc230fd73eb9b1a7/image-1716550258687" alt="" class="md:max-w-lg sm:rounded-lg">
            </div>
            <div class="max-w-2xl sm:px-0 lg:max-w-2xl space-y-3">
              <p class="font-semibold text-primary">
                Premium Web Services
              </p>
              <h2 class="text-3xl font-heading font-semibold text-foreground sm:text-4xl">
                Leverage AI for Your SaaS Development
              </h2>
              <p class="text-foreground/50 text-base">
                Unlock the potential of AI to create robust SaaS solutions. Partner with our specialists to elevate your project with innovative technology and customized support.
              </p>
              <a href="" class="flex items-center gap-1 text-primary font-medium duration-200 hover:text-primary/80">
                  Discover More
                  ${toStr(
                    <FaArrowRightLong className="h-4 w-4"/>
                  )}
              </a>
            </div>
          </div>
        </div>
    </section>

      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "FAQs Simple",
    categ: ["sections", "faqs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-1 items-center">
          <div className="w-1/2 bg-lime-600 h-2 rounded-lg"></div>
          <div className="flex gap-2 w-full">
            <div className="flex flex-col gap-2 w-full flex-1 h-16 justify-center">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="flex flex-col gap-2 w-full flex-1 h-16 justify-center">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">FAQs Simple</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section id="faqs" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14 mx-auto">
          <!-- Title -->
          <div data-aos="fade-up" class="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
            <h2 class="text-2xl font-heading font-semibold md:text-3xl md:leading-tight text-primary">
              Frequently Asked Questions
            </h2>
          </div>
          <!-- End Title -->
        
          <div data-aos="fade-up" class="max-w-5xl mx-auto">
            <!-- Grid -->
            <div class="grid sm:grid-cols-2 gap-6 md:gap-12">
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  Can I cancel at any time?
                </h3>
                <p class="mt-2 text-foreground/80">
                  Yes, you can cancel your subscription at any time. We would appreciate any feedback you have to improve our service.
                </p>
              </div>
              <!-- End Col -->
        
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  My team has credits. How do we use them?
                </h3>
                <p class="mt-2 text-foreground/80">
                  Once your team signs up for a subscription plan, you can allocate credits to various members. This helps manage resources efficiently.
                </p>
              </div>
              <!-- End Col -->
        
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  How does pricing work?
                </h3>
                <p class="mt-2 text-foreground/80">
                  Our pricing is tiered based on the number of users and features required. Contact us for a custom quote tailored to your needs.
                </p>
              </div>
              <!-- End Col -->
        
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  How secure is the service?
                </h3>
                <p class="mt-2 text-foreground/80">
                  We prioritize security and employ the latest measures to ensure your data is protected at all times.
                </p>
              </div>
              <!-- End Col -->
        
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  Do you offer discounts?
                </h3>
                <p class="mt-2 text-foreground/80">
                  We offer built-in discounts at each tier for teams. Contact us to learn more about our discount programs.
                </p>
              </div>
              <!-- End Col -->
        
              <div>
                <h3 class="text-lg font-heading font-semibold text-foreground">
                  What is your refund policy?
                </h3>
                <p class="mt-2 text-foreground/80">
                  We offer refunds within a certain period. Our goal is to ensure customer satisfaction and build strong relationships.
                </p>
              </div>
              <!-- End Col -->
            </div>
            <!-- End Grid -->
          </div>
        </section>
        <!-- End FAQ -->        
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "FAQs Categ",
    categ: ["sections", "faqs"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="flex gap-4 h-full">
            <div className="flex flex-col w-full flex-1 gap-2">
              <div className="bg-lime-600 h-3 rounded-md w-full"></div>
              <div className="bg-zinc-700 h-2 rounded-md w-full"></div>
            </div>
            <div className="flex flex-col gap-2 w-full flex-1">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">FAQs Categ</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
        <section id="faq" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14 mx-auto">
          <div class="grid md:grid-cols-5 gap-10">
            <div data-aos="fade-up" class="md:col-span-2">
              <div class="max-w-xs">
                <h2 class="text-2xl font-heading font-semibold md:text-4xl md:leading-tight text-primary">Frequently<br>asked questions</h2>
                <p class="mt-1 hidden md:block text-foreground/80">Answers to the most frequently asked questions.</p>
              </div>
            </div>

            <div data-aos="fade-up" class="md:col-span-3">
              <!-- Accordion -->
              <div class="divide-y divide-foreground/20">
                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    Can I cancel at anytime?
                  </summary>
                  <p class="text-foreground mt-2">
                    Yes, you can cancel your subscription at any time. We would appreciate any feedback you have to improve our service.
                  </p>
                </details>

                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    My team has credits. How do we use them?
                  </summary>
                  <p class="text-foreground mt-2">
                    Once your team signs up for a subscription plan, you can allocate credits to various members. This helps manage resources efficiently.
                  </p>
                </details>

                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    How does pricing work?
                  </summary>
                  <p class="text-foreground mt-2">
                    Our pricing is tiered based on the number of users and features required. Contact us for a custom quote tailored to your needs.
                  </p>
                </details>

                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    How secure is the service?
                  </summary>
                  <p class="text-foreground mt-2">
                    We prioritize security and employ the latest measures to ensure your data is protected at all times.
                  </p>
                </details>

                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    How do I get access to a theme I purchased?
                  </summary>
                  <p class="text-foreground mt-2">
                    You can access your purchased themes through your account dashboard. If you have any issues, our support team is here to help.
                  </p>
                </details>

                <details>
                  <summary style="list-style: none;" class="cursor-pointer py-3 w-full md:text-lg font-semibold text-start text-foreground">
                    Can I upgrade my license type?
                  </summary>
                  <p class="text-foreground mt-2">
                    Yes, you can upgrade your license at any time. The cost of your current license will be applied to the new purchase.
                  </p>
                </details>
              </div>
            </div>
          </div>
        </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Features Steps",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-2 h-full">
            <div className="bg-zinc-700 h-20 rounded-md flex-1"></div>
            <div className="flex flex-col gap-2 w-full flex-1">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="bg-lime-600 h-2 w-5 rounded-full"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Feature Steps</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:pt-20 lg:pb-20">
        <div data-aos="fade-up" class="max-w-6xl mx-auto">
          <div class="max-w-3xl mb-10 lg:mb-14">
            <h2 class="text-primary font-heading text-2xl md:text-4xl md:leading-tight font-semibold">Our Approach</h2>
            <p class="mt-1 text-foreground/80">Our comprehensive strategy is driven by AI-powered insights, from meticulous research and strategic planning to seamless execution of web design and development.</p>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 lg:items-center">
            <div class="aspect-w-16 aspect-h-9 lg:aspect-none">
              <img class="w-full object-cover rounded-xl" src="https://images.unsplash.com/photo-1523740827771-f9474178ff66?q=80&w=2865&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Image Description">
            </div>

            <div>
              <div class="mb-4">
                <h3 class="text-primary text-xs font-medium uppercase">Steps</h3>
              </div>

              <div class="flex gap-x-5 ms-1">
                <div class="relative last:after:hidden after:absolute after:top-8 after:bottom-0 after:start-4 after:w-px after:-translate-x-[0.5px] after:bg-foreground/80">
                  <div class="relative z-10 size-8 flex justify-center items-center">
                    <span class="flex flex-shrink-0 justify-center items-center size-8 border border-foreground/80 text-primary font-semibold text-xs uppercase rounded-full">
                      1
                    </span>
                  </div>
                </div>

                <div class="grow pt-0.5 pb-8 sm:pb-12">
                  <p class="text-sm lg:text-base text-foreground/80">
                    <span class="text-foreground">AI Market Research:</span> Leverage AI to identify your target audience and understand their needs, preferences, and behaviors.
                  </p>
                </div>
              </div>

              <div class="flex gap-x-5 ms-1">
                <div class="relative last:after:hidden after:absolute after:top-8 after:bottom-0 after:start-4 after:w-px after:-translate-x-[0.5px] after:bg-foreground/80">
                  <div class="relative z-10 size-8 flex justify-center items-center">
                    <span class="flex flex-shrink-0 justify-center items-center size-8 border border-foreground/80 text-primary font-semibold text-xs uppercase rounded-full">
                      2
                    </span>
                  </div>
                </div>

                <div class="grow pt-0.5 pb-8 sm:pb-12">
                  <p class="text-sm lg:text-base text-foreground/80">
                    <span class="text-foreground">AI Product Development:</span> Use AI-driven tools to develop and test digital products or services tailored to your audience.
                  </p>
                </div>
              </div>

              <div class="flex gap-x-5 ms-1">
                <div class="relative last:after:hidden after:absolute after:top-8 after:bottom-0 after:start-4 after:w-px after:-translate-x-[0.5px] after:bg-foreground/80">
                  <div class="relative z-10 size-8 flex justify-center items-center">
                    <span class="flex flex-shrink-0 justify-center items-center size-8 border border-foreground/80 text-primary font-semibold text-xs uppercase rounded-full">
                      3
                    </span>
                  </div>
                </div>

                <div class="grow pt-0.5 pb-8 sm:pb-12">
                  <p class="text-sm md:text-base text-foreground/80">
                    <span class="text-foreground">AI Marketing Strategy:</span> Develop a comprehensive marketing strategy using AI to promote your digital products or services effectively.
                  </p>
                </div>
              </div>

              <div class="flex gap-x-5 ms-1">
                <div class="relative last:after:hidden after:absolute after:top-8 after:bottom-0 after:start-4 after:w-px after:-translate-x-[0.5px] after:bg-foreground/80">
                  <div class="relative z-10 size-8 flex justify-center items-center">
                    <span class="flex flex-shrink-0 justify-center items-center size-8 border border-foreground/80 text-primary font-semibold text-xs uppercase rounded-full">
                      4
                    </span>
                  </div>
                </div>

                <div class="grow pt-0.5 pb-8 sm:pb-12">
                  <p class="text-sm md:text-base text-foreground/80">
                    <span class="text-foreground">Launch and Optimize:</span> Launch your digital products or services to the market, using AI to monitor performance and gather user feedback for optimization.
                  </p>
                </div>
              </div>

              <a class="group inline-flex items-center gap-x-2 py-2 px-3 bg-primary font-medium text-sm text-background rounded-full focus:outline-none" href="#">
                <svg class="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path><path class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 group-hover:delay-100 transition" d="M14.05 2a9 9 0 0 1 8 7.94"></path><path class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition" d="M14.05 6A5 5 0 0 1 18 10"></path></svg>
                Let's Get Started
              </a>
            </div>
          </div>
        </div>
      </section>
    `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Features with Side Image",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="flex gap-2 h-full">
            <div className="bg-zinc-700 h-16 rounded-md flex-1"></div>
            <div className="flex flex-col gap-2 w-full flex-1 h-16 justify-center">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Features with Side Image</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14">
        <div data-aos="fade-up" class="mx-auto max-w-8xl ">
          <div class="md:grid md:grid-cols-2 md:items-center md:gap-12 xl:gap-32">
            <img class="rounded-xl" src="https://images.unsplash.com/photo-1475276984180-2762e8fdb82f?q=80&w=2944&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Image Description" >
            <div class="mt-5 sm:mt-10 lg:mt-0">
              <div class="space-y-6 sm:space-y-8">
                <div class="space-y-2 md:space-y-4">
                  <h2 class="font-heading text-3xl lg:text-4xl text-foreground">
                    Solving Start-Up Challenges with AI
                  </h2>
                  <p class="text-foreground/80">
                    Our AI-driven tools are designed to assist startups in overcoming common hurdles, streamlining digital transformation, and providing solutions to recurring issues.
                  </p>
                </div>

                <ul class="space-y-2 sm:space-y-4">
                  <li class="flex space-x-3">
                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary text-foreground">
                      <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>

                    <span class="text-sm sm:text-base text-foreground/80">
                      <span class="font-bold">Effortless & Swift</span> Design
                    </span>
                  </li>

                  <li class="flex space-x-3">
                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary text-foreground">
                      <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>

                    <span class="text-sm sm:text-base text-foreground/80">
                      Powerful <span class="font-bold">AI Features</span>
                    </span>
                  </li>

                  <li class="flex space-x-3">
                    <span class="mt-0.5 size-5 flex justify-center items-center rounded-full bg-primary text-foreground">
                      <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>

                    <span class="text-sm sm:text-base text-foreground/80">
                      User-Centric <span class="font-bold">Design</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Feature Stats",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="flex gap-5 items-center">
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-3 w-3 rounded-md p-2"></div>
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md "></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md "></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md "></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Features Stats</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="stats" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14">
        <!-- Grid -->
        <div data-aos="fade-up" class="grid items-center lg:grid-cols-12 gap-6 lg:gap-12">
          <div class="lg:col-span-4">
            <!-- Stats -->
            <div class="lg:pe-6 xl:pe-12">
              <p class="text-6xl font-bold leading-10 text-primary">
                92%
                <span class="ms-1 inline-flex items-center gap-x-1 bg-foreground/20 font-medium text-foreground text-xs leading-4 rounded-full py-0.5 px-2">
                  <svg class="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                  </svg>
                  +7% this month
                </span>
              </p>
              <p class="mt-2 sm:mt-3 text-foreground/80">of users have enhanced their business with our AI builder</p>
            </div>
            <!-- End Stats -->
          </div>
          <!-- End Col -->

          <div class="lg:col-span-8 relative lg:before:absolute lg:before:top-0 lg:before:-start-12 lg:before:w-px lg:before:h-full lg:before:bg-foreground/20 lg:before:">
            <div class="grid gap-6 grid-cols-2 md:grid-cols-4 lg:grid-cols-3 sm:gap-8">
              <!-- Stats -->
              <div>
                <p class="text-3xl font-semibold text-primary">99.95%</p>
                <p class="mt-1 text-foreground/80">order fulfillment rate</p>
              </div>
              <!-- End Stats -->

              <!-- Stats -->
              <div>
                <p class="text-3xl font-semibold text-primary">2,000+</p>
                <p class="mt-1 text-foreground/80">trusted partnerships</p>
              </div>
              <!-- End Stats -->

              <!-- Stats -->
              <div>
                <p class="text-3xl font-semibold text-primary">85%</p>
                <p class="mt-1 text-foreground/80">customer satisfaction rate</p>
              </div>
              <!-- End Stats -->
            </div>
          </div>
          <!-- End Col -->
        </div>
        <!-- End Grid -->
      </section>
      <!-- End Features -->
        
    `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Feature with Top Image",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="bg-zinc-700 h-6 w-full rounded-md"></div>
          <div className="flex gap-3">
            <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
            <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Features Top Image</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14">
        <div data-aos="fade-up" class="max-w-[85rem] mx-auto">
          <div data-aos="fade-up" class="w-full">
            <img class="w-full max-h-80 object-cover rounded-xl" src="https://images.unsplash.com/photo-1499540633125-484965b60031?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Image Description">
          </div>

          <div data-aos="fade-up" class="mt-5 lg:mt-16 grid lg:grid-cols-3 gap-8 lg:gap-12">
            <div class="lg:col-span-1">
              <h2 class="font-heading text-2xl md:text-3xl text-foreground">
                Overcoming Challenges in AI Website Building
              </h2>
              <p class="mt-2 md:mt-4 text-foreground/80">
                Our AI website builder is designed to address common challenges in digital transformation, making it easier for startups to create and manage their online presence efficiently.
              </p>
            </div>

            <div class="lg:col-span-2">
              <div class="grid sm:grid-cols-2 gap-8 md:gap-12">
                <div class="flex gap-x-5">
                  <svg class="flex-shrink-0 mt-1 size-6 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="10" x="3" y="11" rx="2"/><circle cx="12" cy="5" r="2"/><path d="M12 7v4"/><line x1="8" x2="8" y1="16" y2="16"/><line x1="16" x2="16" y1="16" y2="16"/></svg>
                  <div class="grow">
                    <h3 class="text-lg font-semibold text-foreground">
                      Innovative Solutions
                    </h3>
                    <p class="mt-1 text-foreground/80">
                      Our team combines creativity and technology to deliver cutting-edge AI solutions for your website building needs.
                    </p>
                  </div>
                </div>

                <div class="flex gap-x-5">
                  <svg class="flex-shrink-0 mt-1 size-6 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z"/></svg>
                  <div class="grow">
                    <h3 class="text-lg font-semibold text-foreground">
                      Cost-Effective
                    </h3>
                    <p class="mt-1 text-foreground/80">
                      Our AI tools help you save time and money, allowing you to focus on growing your business.
                    </p>
                  </div>
                </div>

                <div class="flex gap-x-5">
                  <svg class="flex-shrink-0 mt-1 size-6 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                  <div class="grow">
                    <h3 class="text-lg font-semibold text-foreground">
                      Comprehensive Resources
                    </h3>
                    <p class="mt-1 text-foreground/80">
                      Access extensive documentation and libraries to streamline your website building process.
                    </p>
                  </div>
                </div>

                <div class="flex gap-x-5">
                  <svg class="flex-shrink-0 mt-1 size-6 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                  <div class="grow">
                    <h3 class="text-lg font-semibold text-foreground">
                      User-Centric Design
                    </h3>
                    <p class="mt-1 text-foreground/80">
                      We prioritize user experience, ensuring your website is both functional and visually appealing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Team Section Basic",
    categ: ["sections", "team","people"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col items-start gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-3 w-full justify-between">
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded-full"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Team Basic
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="team" class="w-full bg-background text-foreground font-body py-14 px-6 sm:px-12 md:px-20">
        <div data-aos="fade-up" class="max-w-screen-xl mx-auto">
            <div class="w-full flex flex-col">
                <h2 class="max-w-xl font-heading text-foreground text-3xl font-semibold sm:text-4xl">
                    Meet Our <span class="text-primary">AI Experts<span>
                </h2>
            </div>
            <div class="mt-12">
                <ul class="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    <li class="flex gap-4 items-center">
                        <div class="w-32 h-32 rounded-full border-8 border-primary/20 overflow-hidden">
                            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652564786" class="w-full h-auto object-cover" alt="team person"/>
                        </div>
                        <div>
                            <h4 class="text-foreground/80 font-semibold sm:text-lg">Alexandra Smith</h4>
                            <p class="text-foreground/60">Lead Product Manager</p>
                            <div class="mt-3 flex gap-4 text-foreground/50">
                                <a href="/">
                                    ${toStr(<FaTwitter className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaLinkedin className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaInstagram className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="flex gap-4 items-center">
                        <div class="w-32 h-32 rounded-full border-8 border-primary/20 overflow-hidden">
                            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652448850" class="w-full h-auto object-cover" alt="team person"/>
                        </div>
                        <div>
                            <h4 class="text-foreground/80 font-semibold sm:text-lg">Daniel Johnson</h4>
                            <p class="text-foreground/60">Senior Engineer</p>
                            <div class="mt-3 flex gap-4 text-foreground/50">
                                <a href="/">
                                    ${toStr(<FaTwitter className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaLinkedin className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaInstagram className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="flex gap-4 items-center">
                        <div class="w-32 h-32 rounded-full border-8 border-primary/20 overflow-hidden">
                            <img src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652574884" class="w-full h-auto object-cover" alt="team person"/>
                        </div>
                        <div>
                            <h4 class="text-foreground/80 font-semibold sm:text-lg">Sophia Williams</h4>
                            <p class="text-foreground/60">AI. Engineer</p>
                            <div class="mt-3 flex gap-4 text-foreground/50">
                                <a href="/">
                                    ${toStr(<FaTwitter className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaLinkedin className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                                <a href="/">
                                    ${toStr(<FaInstagram className="w-5 h-auto hover:text-foreground/60"/>)}
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    }
  },
  {
    name: "Team Square",
    categ: ["sections", "team","people"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col items-center gap-3">
          <div className="bg-zinc-600 h-2 w-1/2 rounded-md"></div>
          <div className="flex gap-3 w-full justify-between">
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
          <div className="flex gap-3 w-full justify-between">
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
            <div className="rounded-md flex-1 flex gap-1 p-0">
              <div className="bg-lime-600 h-3 w-3 rounded"></div>
              <div className="w-5 bg-zinc-700 h-2 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Team Square
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="team" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-14">
        <div data-aos="fade-up" class="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
          <h2 class="text-2xl font-bold md:text-4xl md:leading-tight">Meet Our Team</h2>
          <p class="mt-1 text-foreground/80">Innovators and Experts Driving Our AI Website Builder</p>
        </div>
        <div data-aos="fade-up" class="grid grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652564786" alt="Alex Johnson, CEO">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">Alex Johnson</h3>
                <p class="mt-1 text-xs uppercase text-foreground/80">Founder / CEO</p>
              </div>
              <div class="mt-2 sm:mt-auto flex gap-3 text-foreground/50">
                <a href="/">
                  ${toStr(<FaTwitter className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaLinkedin className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaInstagram className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
              </div>
            </div>
          </div>
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652448850" alt="Sarah Williams, UI/UX Designer">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">Sarah Williams</h3>
                <p class="mt-1 text-xs uppercase text-foreground/80">UI/UX Designer</p>
              </div>
              <div class="mt-2 sm:mt-auto flex gap-3 text-foreground/50">
                <a href="/">
                  ${toStr(<FaTwitter className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaLinkedin className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaInstagram className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
              </div>
            </div>
          </div>
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=900&h=900&q=80" alt="Michael Brown, Support Specialist">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">Michael Brown</h3>
                <p class="mt-1 text-xs uppercase text-foreground/80">Support Specialist</p>
              </div>
              <div class="mt-2 sm:mt-auto flex gap-3 text-foreground/50">
                <a href="/">
                  ${toStr(<FaTwitter className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaLinkedin className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaInstagram className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
              </div>
            </div>
          </div>
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://images.unsplash.com/photo-1579017331263-ef82f0bbc748?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=900&h=900&q=80" alt="Emma Stone, AI Developer">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">Emma Stone</h3>
                <p class="mt-1 text-xs uppercase text-foreground/80">AI Developer</p>
              </div>
              <div class="mt-2 sm:mt-auto flex gap-3 text-foreground/50">
                <a href="/">
                  ${toStr(<FaTwitter className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaLinkedin className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaInstagram className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
              </div>
            </div>
          </div>
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-66510119c495ade1148315ae/image-1716652574884" alt="John Doe, Project Manager">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">John Doe</h3>
                <p class="mt-1 text-xs uppercase text-foreground/80">Project Manager</p>
              </div>
              <div class="mt-2 sm:mt-auto flex gap-3 text-foreground/50">
                <a href="/">
                  ${toStr(<FaTwitter className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaLinkedin className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
                <a href="/">
                  ${toStr(<FaInstagram className="w-4 h-auto hover:text-foreground/60"/>)}
                </a>
              </div>
            </div>
          </div>
          <div class="grid sm:flex sm:items-center gap-y-3 gap-x-4">
            <img class="rounded-lg size-20" src="https://s3.us-west-2.amazonaws.com/makeweb.ai/uploads/user-zishansami102@gmail.com/websiteId-6653136ac495ade114831bed/image-1716728428206" alt="We are hiring!">
            <div class="sm:flex sm:flex-col sm:h-full">
              <div>
                <h3 class="font-medium text-foreground">Join Our Team!</h3>
                <a class="text-sm text-primary decoration-2 hover:underline" href="#">
                  Check out / Careers
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    }
  },
  {
    name: "Features Basic",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="flex gap-5 items-center">
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md"></div>
              <div className="w-full bg-zinc-700 h-3 rounded"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md"></div>
              <div className="w-full bg-zinc-700 h-3 rounded"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md"></div>
              <div className="w-full bg-zinc-700 h-3 rounded"></div>
            </div>
            <div className="rounded-md flex-1 flex flex-col items-left gap-2">
              <div className="bg-lime-600 h-2 w-2 rounded-md"></div>
              <div className="w-full bg-zinc-700 h-3 rounded"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Features Basic
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="features" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14">
        <div data-aos="fade-up" class="max-w-[85rem] mx-auto">
          <div class="grid sm:grid-cols-2 lg:grid-cols-4 items-center sm:items-start gap-12">
            <div>
              <svg class="flex-shrink-0 size-9 text-foreground" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="10" height="14" x="3" y="8" rx="2"/><path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"/><path d="M8 18h.01"/></svg>
              <div class="bg-gradient-to-r from-foreground/20 via-foreground/10 to-transparent h-0.5 mt-6">
                <div class="bg-primary w-9 h-0.5"></div>
              </div>
              <div class="mt-5">
                <h3 class="text-lg font-semibold text-foreground">Responsive</h3>
                <p class="mt-1 text-foreground/80">Create responsive, mobile-first websites with ease.</p>
              </div>
            </div>
            <div>
              <svg class="flex-shrink-0 size-9 text-foreground" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/></svg>
              <div class="bg-gradient-to-r from-foreground/20 via-foreground/10 to-transparent h-0.5 mt-6">
                <div class="bg-primary w-9 h-0.5"></div>
              </div>
              <div class="mt-5">
                <h3 class="text-lg font-semibold text-foreground">Customizable</h3>
                <p class="mt-1 text-foreground/80">Easily customize and extend components to fit your needs.</p>
              </div>
            </div>
            <div>
              <svg class="flex-shrink-0 size-9 text-foreground" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              <div class="bg-gradient-to-r from-foreground/20 via-foreground/10 to-transparent h-0.5 mt-6">
                <div class="bg-primary w-9 h-0.5"></div>
              </div>
              <div class="mt-5">
                <h3 class="text-lg font-semibold text-foreground">Comprehensive Documentation</h3>
                <p class="mt-1 text-foreground/80">Detailed documentation for every component and feature.</p>
              </div>
            </div>
            <div>
              <svg class="flex-shrink-0 size-9 text-foreground" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
              <div class="bg-gradient-to-r from-foreground/20 via-foreground/10 to-transparent h-0.5 mt-6">
                <div class="bg-primary w-9 h-0.5"></div>
              </div>
              <div class="mt-5">
                <h3 class="text-lg font-semibold text-foreground">24/7 Support</h3>
                <p class="mt-1 text-foreground/80">Get round-the-clock support for all your needs.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    }
  },
  {
    name: "Features List",
    categ: ["sections", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full bg-zinc-800 p-5 rounded-xl flex flex-col gap-3">
          <div className="flex gap-4 h-full">
            <div className="flex flex-col w-full flex-1 gap-2">
              <div className="bg-zinc-700 h-3 rounded-md w-full"></div>
              <div className="bg-zinc-700 h-2 rounded-md w-full"></div>
            </div>
            <div className="flex flex-col gap-2 w-full flex-1">
              <div className="w-full bg-zinc-700 h-2 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
              <div className="w-full bg-zinc-700 h-1 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Features List
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="icon-blocks" class="relative bg-background text-foreground font-body w-screen px-6 sm:px-12 md:px-20 py-10 lg:py-14">
        <div data-aos="fade-up" class="max-w-[85rem] mx-auto">
          <div class="grid md:grid-cols-2 gap-12">
            <div class="lg:w-3/4">
              <h2 class="text-3xl text-foreground font-heading lg:text-4xl font-semibold">
                AI-Powered Tools for Better User Experience
              </h2>
              <p class="mt-3 text-foreground/80">
                Leverage our AI-driven tools to bring your digital ideas to life, with technology solutions designed to help you succeed.
              </p>
              <p class="mt-5">
                <a class="inline-flex items-center gap-x-1 font-medium text-primary" href="#">
                  Contact sales to learn more
                  <svg class="flex-shrink-0 size-4 transition ease-in-out group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </a>
              </p>
            </div>

            <div class="space-y-6 lg:space-y-10">
              <div class="flex">
                <span class="flex-shrink-0 inline-flex justify-center items-center size-[46px] rounded-full border border-foreground bg-background text-foreground shadow-sm mx-auto">
                  <svg class="flex-shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                </span>
                <div class="ms-5 sm:ms-8">
                  <h3 class="text-base sm:text-lg font-semibold text-foreground">
                    Comprehensive Documentation
                  </h3>
                  <p class="mt-1 text-foreground/80">
                    Our extensive documentation and libraries help you build custom integrations quickly and efficiently.
                  </p>
                </div>
              </div>

              <div class="flex">
                <span class="flex-shrink-0 inline-flex justify-center items-center size-[46px] rounded-full border border-foreground bg-background text-foreground shadow-sm mx-auto">
                  <svg class="flex-shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
                </span>
                <div class="ms-5 sm:ms-8">
                  <h3 class="text-base sm:text-lg font-semibold text-foreground">
                    Developer Community Support
                  </h3>
                  <p class="mt-1 text-foreground/80">
                    We contribute to open-source projects, offering support and collaboration to the developer community.
                  </p>
                </div>
              </div>

              <div class="flex">
                <span class="flex-shrink-0 inline-flex justify-center items-center size-[46px] rounded-full border border-foreground bg-background text-foreground shadow-sm mx-auto">
                  <svg class="flex-shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z"/></svg>
                </span>
                <div class="ms-5 sm:ms-8">
                  <h3 class="text-base sm:text-lg font-semibold text-foreground">
                    Simple and Affordable
                  </h3>
                  <p class="mt-1 text-foreground/80">
                    Our AI tools are designed to be cost-effective and easy to use, helping you save time and resources.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    }
  },
  {
    name: "Footer Simple",
    categ: ["sections", "footer"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full px-3 py-2 bg-zinc-800 rounded flex justify-between items-center">
          <div className="rounded bg-zinc-600 w-3 h-2"></div>
          <div className="rounded bg-zinc-700 w-8 h-1"></div>
          <div className="flex gap-1">
            <div className="rounded bg-zinc-600 w-1 h-1"></div>
            <div className="rounded bg-zinc-600 w-1 h-1"></div>
            <div className="rounded bg-zinc-600 w-1 h-1"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">
          Footer Simple
        </div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section id="footer" class="mt-auto w-full py-10 px-4 sm:px-6 lg:px-8 mx-auto bg-background text-foreground font-body">
        <!-- Grid -->
        <div class="grid grid-cols-1 md:grid-cols-3 items-center gap-5">
          <div>
            <a class="flex-none text-xl font-semibold text-foreground" href="#" aria-label="Brand">Brand</a>
          </div>
          <!-- End Col -->
      
          <ul class="text-center">
            <li class="inline-block relative pe-8 last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:end-3 before:-translate-y-1/2 before:content-['/'] before:text-foreground/30">
              <a class="inline-flex gap-x-2 text-sm text-foreground/70 hover:text-primary" href="#">
                About
              </a>
            </li>
            <li class="inline-block relative pe-8 last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:end-3 before:-translate-y-1/2 before:content-['/'] before:text-foreground/30">
              <a class="inline-flex gap-x-2 text-sm text-foreground/70 hover:text-primary" href="#">
                Services
              </a>
            </li>
            <li class="inline-block relative pe-8 last:pe-0 last-of-type:before:hidden before:absolute before:top-1/2 before:end-3 before:-translate-y-1/2 before:content-['/'] before:text-foreground/30">
              <a class="inline-flex gap-x-2 text-sm text-foreground/70 hover:text-primary" href="#">
                Blog
              </a>
            </li>
          </ul>
          <!-- End Col -->
      
          <!-- Social Brands -->
          <div class="md:text-end space-x-2">
            <a class="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-foreground/70 hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none" href="#">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"/>
              </svg>
            </a>
            <a class="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-foreground/70 hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none" href="#">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
              </svg>
            </a>
            <a class="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-foreground/70 hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none" href="#">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
              </svg>
            </a>
            <a class="size-8 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-foreground/70 hover:bg-foreground/10 disabled:opacity-50 disabled:pointer-events-none" href="#">
              <svg class="flex-shrink-0 size-3.5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M3.362 10.11c0 .926-.756 1.681-1.681 1.681S0 11.036 0 10.111C0 9.186.756 8.43 1.68 8.43h1.682v1.68zm.846 0c0-.924.756-1.68 1.681-1.68s1.681.756 1.681 1.68v4.21c0 .924-.756 1.68-1.68 1.68a1.685 1.685 0 0 1-1.682-1.68v-4.21zM5.89 3.362c-.926 0-1.682-.756-1.682-1.681S4.964 0 5.89 0s1.68.756 1.68 1.68v1.682H5.89zm0 .846c.924 0 1.68.756 1.68 1.681S6.814 7.57 5.89 7.57H1.68C.757 7.57 0 6.814 0 5.89c0-.926.756-1.682 1.68-1.682h4.21zm6.749 1.682c0-.926.755-1.682 1.68-1.682.925 0 1.681.756 1.681 1.681s-.756 1.681-1.68 1.681h-1.681V5.89zm-.848 0c0 .924-.755 1.68-1.68 1.68A1.685 1.685 0 0 1 8.43 5.89V1.68C8.43.757 9.186 0 10.11 0c.926 0 1.681.756 1.681 1.68v4.21zm-1.681 6.748c.926 0 1.682.756 1.682 1.681S11.036 16 10.11 16s-1.681-.756-1.681-1.68v-1.682h1.68zm0-.847c-.924 0-1.68-.755-1.68-1.68 0-.925.756-1.681 1.68-1.681h4.21c.924 0 1.68.756 1.68 1.68 0 .926-.756 1.681-1.68 1.681h-4.21z"/>
              </svg>
            </a>
          </div>
          <!-- End Social Brands -->
        </div>
        <!-- End Grid -->
      </section>
      <!-- End Footer -->      
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
  {
    name: "Cards",
    categ: ["sections", "cards", "features"],
    thumbnail: (
      <div className="w-full py-4 px-4 flex flex-col gap-1 items-center justify-center rounded-2xl">
        <div className="w-full p-5 bg-zinc-800 rounded-xl flex gap-2">
          <div className="bg-zinc-700 h-14 rounded-md flex-1 flex flex-col justify-between text-zinc-300">
            <div className="w-full bg-zinc-700 h-6 rounded-t-md p-2"></div>
            <div className="w-full bg-zinc-900 h-8 rounded-b-md p-2"></div>
          </div>
          <div className="bg-zinc-700 h-14 rounded-md flex-1 flex flex-col justify-between text-zinc-300">
            <div className="w-full bg-zinc-700 h-6 rounded-t-md p-2"></div>
            <div className="w-full bg-zinc-900 h-8 rounded-b-md p-2"></div>
          </div>
          <div className="bg-zinc-700 h-14 rounded-md flex-1 flex flex-col justify-between text-zinc-300">
            <div className="w-full bg-zinc-700 h-6 rounded-t-md p-2"></div>
            <div className="w-full bg-zinc-900 h-8 rounded-b-md p-2"></div>
          </div>
        </div>
        <div className="text-zinc-300 text-xs font-semibold">Cards</div>
      </div>
    ),
    create: () => {
      const htmlCode = `
      <section class="bg-background text-grayshade-800 pt-20 pb-10 lg:pt-[120px] lg:pb-20 px-6 sm:px-12 md:px-20">
        <div data-aos="fade-up mx-auto">
            <div class="flex flex-wrap -mx-4">
              <div class="w-full px-4 md:w-1/2 xl:w-1/3">
                <div class="mb-10 overflow-hidden duration-300 bg-foreground/5 rounded-xl shadow-1 hover:shadow-3">
                  <img src="https://cdn.tailgrids.com/2.0/image/application/images/cards/card-01/image-01.jpg" alt="image" class="w-full"/>
                  <div class="p-8 text-center sm:p-9 md:p-7 xl:p-9">
                      <h3 class="text-foreground mb-4 block text-xl font-semibold sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]">
                        50+ Best creative website themes & templates
                      </h3>
                      <p
                        class="text-base leading-relaxed text-foreground mb-7"
                        >
                        Lorem ipsum dolor sit amet pretium consectetur adipiscing
                        elit. Lorem consectetur adipiscing elit.
                      </p>
                      <a
                        href="#"
                        class="inline-block py-2 text-base font-medium transition border border-foreground/20 rounded-full text-foreground hover:text-white hover:border-primary hover:bg-primary px-7"
                        >
                      View Details
                      </a>
                  </div>
                </div>
              </div>
              <div class="w-full px-4 md:w-1/2 xl:w-1/3">
                  <div
                    class="mb-10 overflow-hidden duration-300 bg-foreground/5 rounded-xl shadow-1 hover:shadow-3"
                    >
                    <img
                        src="https://cdn.tailgrids.com/2.0/image/application/images/cards/card-01/image-02.jpg"
                        alt="image"
                        class="w-full"
                        />
                    <div class="p-8 text-center sm:p-9 md:p-7 xl:p-9">
                        <h3>
                          <a
                            href="/"
                            class="text-foreground mb-4 block text-xl font-semibold sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]"
                            >
                          The ultimate UX and UI guide to card design
                          </a>
                        </h3>
                        <p class="text-base leading-relaxed text-foreground mb-7">
                          Lorem ipsum dolor sit amet pretium consectetur adipiscing
                          elit. Lorem consectetur adipiscing elit.
                        </p>
                        <a class="inline-block py-2 text-base font-medium transition border rounded-full text-foreground hover:border-primary hover:bg-primary border-grayshade-300 px-7 hover:text-foreground">
                        View Details
                        </a>
                    </div>
                  </div>
              </div>
              <div class="w-full px-4 md:w-1/2 xl:w-1/3">
                  <div
                    class="mb-10 overflow-hidden duration-300 bg-foreground/5 rounded-xl shadow-1 hover:shadow-3"
                    >
                    <img
                        src="https://cdn.tailgrids.com/2.0/image/application/images/cards/card-01/image-03.jpg"
                        alt="image"
                        class="w-full"
                        />
                    <div class="p-8 text-center sm:p-9 md:p-7 xl:p-9">
                        <h3>
                          <a class="text-foreground mb-4 block text-xl font-semibold sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]">
                          Creative Card Component designs graphic elements
                          </a>
                        </h3>
                        <p class="text-base leading-relaxed text-foreground mb-7">
                          Lorem ipsum dolor sit amet pretium consectetur adipiscing
                          elit. Lorem consectetur adipiscing elit.
                        </p>
                        <a
                          href="/"
                          class="inline-block py-2 text-base font-medium transition border rounded-full text-foreground hover:border-primary hover:bg-primary border-grayshade-300 px-7 hover:text-foreground"
                          >
                        View Details
                        </a>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </section>
      `;
      const jsonObj = { ...parseHTMLToJson(htmlCode) };
      return jsonObjToRecoilState(jsonObj);
    },
  },
];

const toStr = (comp) => {
  return ReactDOMServer.renderToString(comp);
};
